const messages = {
        es: {
          translations: {
            quickCharge: {
              button: "Cobro rápido",
              title: "Cobro rápido",
              customer: "Cliente",
              amount: "Importe",
              reason: "Motivo",
              defaultReason: "Pago por servicio",
              create: "Crear pago",
              cancel: "Cancelar",
              created: "Solicitud de pago creada",
              linkHint: "Envía el enlace al cliente en el chat, o cópialo",
              noLink: "Solicitud creada, pero no hay cuenta Tranzila configurada para el enlace.",
              noLinkButCreated: "Creado — configura Tranzila para obtener un enlace",
              done: "Cerrar",
              copy: "Copiar enlace",
              copied: "Enlace copiado",
              sendToChat: "Enviar en el chat",
              sent: "Enlace enviado al cliente",
              chatPrefix: "Pago seguro por",
              invalidAmount: "Introduce un importe válido"
            },
            errorBoundary: {
              pageTitle: "Algo salió mal al cargar esta pantalla",
              pageBody: "Intenta recargar. El resto del sistema sigue funcionando.",
              reload: "Recargar",
              sectionFailed: "No se pudo cargar esta sección."
            },
            voiceIntelligence: {
              title: "Voice Intelligence — Centro de Control",
              tabs: {
                overview: "Resumen",
                calls: "Llamadas",
                search: "Búsqueda",
                agents: "Agentes",
                collection: "Cobranza",
                insights: "Insights"
              },
              range: {
                label: "Rango",
                days7: "7 días",
                days30: "30 días",
                days90: "90 días"
              },
              widgets: {
                totalCalls: "Total de llamadas",
                totalDuration: "Duración total",
                avgDuration: "Duración promedio",
                callsToday: "Llamadas hoy",
                callsThisWeek: "Llamadas esta semana",
                callsThisMonth: "Llamadas este mes",
                callsAnalyzed: "Llamadas analizadas",
                callsPendingAnalysis: "Pendientes de análisis",
                collectionCalls: "Llamadas de cobranza",
                vipCalls: "Llamadas VIP",
                followUpRequired: "Requieren seguimiento"
              },
              agents: {
                title: "Llamadas por agente",
                agent: "Agente",
                calls: "Llamadas",
                duration: "Duración total",
                avgDuration: "Promedio",
                unassigned: "Sin asignar",
                empty: "No hay llamadas en el rango seleccionado"
              },
              notEnabled: {
                title: "El módulo de voz no está habilitado",
                body: "Habilite Voice en la configuración o contacte a su administrador."
              },
              calls: {
                filters: {
                  search: "Buscar",
                  agent: "Agente",
                  outcome: "Resultado",
                  has: "Incluye",
                  all: "Todos",
                  hasRecording: "Con grabación",
                  hasTranscript: "Con transcripción",
                  hasAnalysis: "Con análisis IA",
                  qa: "QA",
                  noOutcome: "Sin resultado",
                  noTranscript: "Sin transcripción",
                  noAnalysis: "Sin análisis IA",
                  minMinutes: "Min minutos",
                  maxMinutes: "Max minutos"
                },
                columns: {
                  date: "Fecha",
                  customer: "Cliente",
                  agent: "Agente",
                  outcome: "Resultado",
                  duration: "Duración",
                  tags: "Etiquetas",
                  actions: "Acciones"
                },
                actions: {
                  listen: "Escuchar",
                  download: "Descargar grabación",
                  transcript: "Transcripción",
                  openTicket: "Abrir conversación"
                },
                exportCsv: "Exportar CSV",
                exportXlsx: "Exportar Excel",
                exportSelectedCsv: "Exportar selección CSV",
                exportSelectedXlsx: "Exportar selección Excel",
                selected: "{{count}} seleccionadas",
                empty: "No hay llamadas para los filtros",
                transcriptTitle: "Transcripción de llamada",
                noTranscript: "Transcripción no disponible"
              },
              outcomes: {
                sale: "Venta",
                follow_up: "Seguimiento",
                support: "Soporte",
                collection: "Cobranza",
                complaint: "Queja",
                no_answer: "Sin respuesta",
                wrong_number: "Número equivocado"
              },
              agentsPerf: {
                topSales: "Mejor en ventas",
                topSupport: "Mejor en soporte",
                topCollection: "Mejor en cobranza",
                mostActive: "Más activo",
                highestConversion: "Mayor conversión",
                tableTitle: "Rendimiento de agentes",
                agent: "Agente",
                calls: "Llamadas",
                answered: "Respondidas",
                avgDuration: "Duración media",
                conversion: "Conversión",
                unassigned: "Sin asignar",
                empty: "Sin datos en el rango"
              },
              insights: {
                kpis: {
                  conversionRate: "Tasa de conversión",
                  followUpRate: "Tasa de seguimiento",
                  noAnswerRate: "Tasa sin respuesta",
                  complaintRate: "Tasa de quejas",
                  collectionSuccessRate: "Éxito de cobranza",
                  collectionPromiseRate: "Promesas de pago"
                },
                heatmapTitle: "Mapa de calor — llamadas por hora y día",
                noData: "Sin datos aún",
                topObjections: "Objeciones frecuentes",
                topActionItems: "Acciones frecuentes",
                topIntents: "Temas principales",
                sentiment: "Sentimiento",
                days: {
                  sun: "Dom",
                  mon: "Lun",
                  tue: "Mar",
                  wed: "Mié",
                  thu: "Jue",
                  fri: "Vie",
                  sat: "Sáb"
                },
                ask: {
                  title: "Pregunta a la IA sobre tus llamadas",
                  placeholder: "p. ej. ¿De qué se quejan los clientes este mes?",
                  button: "Preguntar",
                  noData: "No hay suficientes datos para responder"
                }
              },
              collectionTab: {
                filters: {
                  all: "Todo",
                  pending: "Pendiente",
                  promised: "Promesa de pago",
                  paid: "Pagado",
                  overdue: "Vencido"
                },
                columns: {
                  date: "Fecha",
                  customer: "Cliente",
                  agent: "Agente",
                  amountDue: "Deuda",
                  amountPromised: "Prometido",
                  dueDate: "Vencimiento",
                  status: "Estado",
                  actions: "Acciones"
                },
                status: {
                  pending: "Pendiente",
                  promised: "Prometido",
                  paid: "Pagado",
                  failed: "Fallido"
                },
                openTicket: "Abrir conversación",
                empty: "Sin llamadas de cobranza para este filtro"
              },
              branding: {
                title: "Voice Branding",
                note: "Mensaje de bienvenida y música de espera con marca. La reproducción en llamada se activa tras la validación de la Fase 1.",
                enable: "Activar branding de voz",
                welcomeTitle: "Mensaje de bienvenida",
                welcomeText: "Texto de bienvenida (TTS)",
                welcomeTextHint: "Si también hay archivo, el archivo tiene prioridad",
                welcomeAsset: "Archivo de bienvenida (MP3)",
                waitingAsset: "Música de espera (MP3)",
                language: "Idioma",
                none: "Ninguno",
                assetsTitle: "Archivos de audio",
                uploadKind: "Tipo",
                upload: "Subir archivo",
                noAssets: "Sin archivos — suba su primer MP3",
                preview: "Escuchar",
                delete: "Eliminar",
                saved: "Guardado",
                uploaded: "Archivo subido",
                previewFailed: "Error de reproducción",
                kinds: {
                  welcome: "Bienvenida",
                  waiting: "Espera",
                  announcement: "Anuncio"
                }
              },
              search: {
                placeholder: "Buscar en transcripciones, resúmenes IA, memoria del cliente y notas…",
                button: "Buscar",
                results: "{{count}} resultados",
                empty: "Sin resultados — pruebe otra redacción",
                loadMore: "Cargar más",
                openTicket: "Abrir conversación",
                scopes: {
                  all: "Todo",
                  transcripts: "Transcripciones",
                  analyses: "Resúmenes IA",
                  memory: "Memoria del cliente",
                  notes: "Notas"
                },
                sources: {
                  transcript: "Transcripción",
                  analysis: "Análisis IA",
                  memory: "Memoria",
                  notes: "Notas"
                }
              }
            },
            common: {
              yes: "Sí",
              no: "No",
              clean: "Limpiar",
              connection: "Conexión"
            },
            enterprisePlan: {
              title: "Enterprise",
              pricing: "Precio personalizado",
              description: "Plan adaptado a equipos de gran volumen",
              ctaContactSales: "Contactar con ventas"
            },
            buttons: {
              cancel: "Cancelar",
              close: "Cerrar",
              save: "Guardar",
              confirm: "Confirmar",
              ok: "OK",
              import: "Importar",
              all: "Todos"
            },
            signup: {
              title: "Registrarse",
              toasts: {
                success: "Usuario creado con éxito. ¡Inicia sesión ahora!",
                fail: "Error al crear usuario. Verifica los datos proporcionados."
              },
              form: {
                name: "Nombre",
                email: "Correo electrónico",
                password: "Contraseña"
              },
              buttons: {
                submit: "Registrarse",
                login: "¿Ya tienes una cuenta? ¡Inicia sesión!"
              }
            },
            admin: {
              tag: "Admin",
              exit: "Volver al espacio de trabajo",
              enterSoftware: "Entrar al software",
              nav: {
                heading: "Plataforma",
                overview: "Resumen",
                companies: "Empresas",
                plans: "Planes",
                subscriptions: "Suscripciones",
                audit: "Registro de auditoría",
                compare: "Comparar",
                broadcasts: "Anuncios",
                pages: "Páginas"
              },
              broadcast: {
                title: "Anuncios",
                subtitle: "Banners para todos los tenants o uno específico",
                refresh: "Refrescar",
                compose: "Nuevo anuncio",
                publish: "Publicar",
                publishing: "Publicando…",
                cancel: "Cancelar",
                empty: "Sin anuncios aún. Crea el primero arriba.",
                loadError: "No se pudo cargar.",
                actionFailed: "Acción fallida",
                createFailed: "No se pudo publicar.",
                titleBodyRequired: "Título y cuerpo son obligatorios.",
                tenantTargetRequired: "Elige una empresa objetivo.",
                created: "Anuncio publicado.",
                confirmDelete: "¿Eliminar \"{{title}}\"? No se puede deshacer.",
                endsOn: "hasta {{date}}",
                col: {
                  title: "Mensaje",
                  severity: "Severidad",
                  audience: "Audiencia",
                  created: "Creado",
                  actions: "Acciones"
                },
                audience: {
                  all: "Todos los tenants",
                  tenant: "Tenant específico"
                },
                form: {
                  title: "Título",
                  body: "Cuerpo",
                  severity: "Severidad",
                  audience: "Audiencia",
                  target: "Empresa objetivo",
                  endsAt: "Expira (opcional)"
                },
                tooltip: {
                  active: "Activa (toca para detener)",
                  stopped: "Detenida (toca para activar)"
                },
                aria: {
                  active: "Difusión activa",
                  stopped: "Difusión detenida"
                }
              },
              compare: {
                title: "Comparar tenants",
                subtitle: "{{count}} de {{max}} seleccionados · KPI operativos lado a lado",
                add: "Añadir tenant",
                remove: "Quitar",
                searchPlaceholder: "Buscar por nombre de empresa…",
                pickerEmpty: "Sin coincidencias.",
                noPlan: "Sin plan",
                slotEmpty: "—",
                empty: {
                  title: "Elige tenants para comparar",
                  sub: "Añade hasta 4 empresas — sus KPI operativos se mostrarán lado a lado."
                },
                row: {
                  metric: "Métrica",
                  status: "Salud",
                  msgs24h: "Msgs 24h",
                  tickets: "Tickets abiertos",
                  closed24h: "{{count}} cerrados",
                  whatsapp: "WhatsApp",
                  users: "Usuarios",
                  queuesN: "{{count}} colas",
                  ai: "AI worker",
                  spark: "Volumen 7d"
                }
              },
              audit: {
                title: "Registro de auditoría",
                subtitle: "Toda acción de operadores de plataforma sobre todos los tenants",
                refresh: "Refrescar",
                reset: "Restablecer",
                empty: "Sin entradas que coincidan con tus filtros.",
                filter: {
                  action: "Acción",
                  allActions: "Todas las acciones",
                  admin: "Admin",
                  allAdmins: "Todos los admins",
                  since: "Desde",
                  until: "Hasta"
                },
                col: {
                  when: "Cuándo",
                  admin: "Admin",
                  action: "Acción",
                  target: "Destino",
                  ip: "IP"
                },
                pagination: {
                  showing: "Mostrando {{start}}–{{end}} de {{total}}",
                  prev: "Anterior",
                  next: "Siguiente"
                }
              },
              overview: {
                title: "Resumen de empresas",
                subtitle: "Métricas a nivel de plataforma de todos los tenants",
                loadError: "No se pudo cargar el resumen. Inténtalo de nuevo.",
                empty: "Aún no hay datos.",
                kpi: {
                  companies: "Empresas",
                  active: "Activas",
                  expiringSoon: "Vencen pronto",
                  within7Days: "En 7 días",
                  mrr: "MRR (est.)",
                  mrrSub: "Equivalente mensual",
                  newThisMonth: "+{{count}} este mes"
                },
                signups: {
                  title: "Altas (últimos 6 meses)",
                  sub: "Nuevas empresas por mes"
                },
                plans: {
                  title: "Distribución de planes",
                  sub: "Proporción de empresas por nivel"
                },
                expiring: {
                  title: "Vencen pronto",
                  viewAll: "Ver todas",
                  empty: "Sin vencimientos en los próximos 7 días.",
                  today: "hoy",
                  tomorrow: "mañana",
                  inDays: "en {{days}} días"
                },
                attention: {
                  title: "Requiere atención",
                  sub: "Solo conteos — abre Empresas para actuar",
                  suspended: "Suspendidas",
                  pastDue: "Vencidas",
                  aiOff: "IA desactivada",
                  openCompanies: "Abrir Empresas"
                },
                activity: {
                  title: "Actividad reciente de la plataforma",
                  viewAll: "Ver registro completo",
                  empty: "Sin acciones de plataforma registradas aún.",
                  now: "ahora mismo",
                  minAgo: "hace {{count}} min",
                  hAgo: "hace {{count}} h",
                  dAgo: "hace {{count}} días"
                }
              },
              health: {
                backToCompanies: "Volver a Empresas",
                loadError: "No se pudo cargar la información del tenant.",
                actionFailed: "Acción fallida",
                justNow: "ahora",
                status: {
                  healthy: "Saludable",
                  watch: "Vigilar",
                  critical: "Crítico"
                },
                reason: {
                  suspended: "suspendido",
                  no_whatsapp_session: "sin sesión WhatsApp",
                  whatsapp_disconnected: "WhatsApp desconectado",
                  no_activity_24h: "sin actividad 24h",
                  past_due: "vencido",
                  expiring_soon: "expira pronto"
                },
                kpi: {
                  msgs24h: "Mensajes (24h)",
                  totalLast24h: "Entrantes + salientes",
                  ticketsOpen: "Tickets abiertos",
                  closed24h: "{{count}} cerrados en 24h",
                  whatsapps: "WhatsApp",
                  connectedTotal: "Conectados / total",
                  users: "Usuarios",
                  queues: "{{count}} colas"
                },
                volume: {
                  title: "Volumen de mensajes (7 días)",
                  sub: "Conteos diarios"
                },
                config: {
                  title: "Configuración",
                  sub: "Solo metadatos",
                  ai: "AI worker",
                  aiPromptSize: "Tamaño del prompt AI",
                  chars: "car.",
                  queues: "Colas",
                  settings: "Filas de ajustes",
                  dueDate: "Fecha de vencimiento",
                  on: "On",
                  off: "Off"
                },
                activity: {
                  title: "Acciones recientes de admin",
                  sub: "Solo operadores de plataforma",
                  empty: "Sin acciones de plataforma para este tenant.",
                  byUser: "admin #{{id}}"
                },
                action: {
                  impersonate: "Iniciar como tenant",
                  ai_enable: "AI activado",
                  ai_disable: "AI desactivado",
                  suspend_tenant: "Suspendido",
                  reactivate_tenant: "Reactivado"
                },
                actions: {
                  enableAi: "Activar AI",
                  disableAi: "Desactivar AI",
                  suspend: "Suspender",
                  reactivate: "Reactivar"
                },
                aiToggle: {
                  enabled: "AI activado",
                  disabled: "AI desactivado"
                },
                confirm: {
                  suspend: "¿Suspender {{name}}? No podrán iniciar sesión.",
                  reactivate: "¿Reactivar {{name}}?"
                },
                suspended: "Suspendido",
                reactivated: "Reactivado",
                toggleAiTip: "Activar o desactivar AI para este tenant"
              }
            },
            login: {
              title: "Bienvenido de nuevo",
              subtitle: "Inicia sesión para continuar en tu espacio de trabajo",
              form: {
                email: "Correo electrónico",
                password: "Contraseña",
                remember: "Recuérdame",
                forgot: "¿Olvidaste tu contraseña?"
              },
              buttons: {
                submit: "Entrar",
                register: "¿No tienes una cuenta? ¡Regístrate!",
                haveAccount: "¿Nuevo por aquí?"
              },
              brand: {
                meta: "CRM de WhatsApp",
                h1: "Conversaciones",
                h2a: "que ",
                h2b: "cierran",
                h3: "tratos.",
                subhead: "CRM de WhatsApp con IA que te ayuda a gestionar, automatizar y cerrar más tratos — todo en un solo lugar.",
                f1: {
                  t: "Todas las conversaciones en un solo lugar",
                  b: "Nunca pierdas un mensaje. Mantén el orden."
                },
                f2: {
                  t: "Automatiza y ahorra tiempo",
                  b: "Automatización inteligente para resultados más rápidos."
                },
                f3: {
                  t: "Insights que impulsan el crecimiento",
                  b: "Sabe más, decide mejor, cierra más."
                }
              },
              secure: {
                title: "Seguro y cifrado",
                body: "Tus datos están a salvo con nosotros"
              }
            },
            companies: {
              title: "Registrar Empresa",
              form: {
                name: "Nombre de la Empresa",
                plan: "Plan",
                token: "Token",
                submit: "Registrar",
                success: "Empresa creada con éxito"
              }
            },
            plansManager: {
              form: {
                name: "Nombre del plan",
                isPublic: "Público",
                value: "Precio",
                users: "Usuarios",
                connections: "Conexiones",
                queues: "Colas",
                options: {
                  yes: "Sí",
                  no: "No"
                },
                buttons: {
                  clear: "Limpiar",
                  delete: "Eliminar",
                  save: "Guardar"
                }
              },
              table: {
                name: "Nombre",
                users: "Usuarios",
                isPublic: "Público",
                connections: "Conexiones",
                queues: "Colas",
                value: "Precio"
              },
              toasts: {
                loadError: "No se pudo cargar la lista de planes.",
                success: "¡La operación se completó correctamente!",
                saveError: "No se pudo completar la operación. Verifique si ya existe un plan con el mismo nombre o si los campos son válidos.",
                deleteError: "No se pudo completar la operación."
              },
              confirmation: {
                title: "Confirmación de eliminación",
                message: "¿Está seguro de que desea eliminar este registro?"
              }
            },
            companiesManager: {
              form: {
                name: "Nombre",
                email: "E-mail",
                phone: "Teléfono",
                plan: "Plan",
                status: "Estado",
                expiration: "Fecha de expiración"
              },
              table: {
                name: "Nombre",
                email: "E-mail",
                phone: "Teléfono",
                plan: "Plan",
                status: "Estado",
                createdAt: "Creado",
                expiration: "Expiración"
              }
            },
            auth: {
              toasts: {
                success: "Inicio de sesión exitoso"
              },
              token: "Token"
            },
            dashboard: {
              filter: {
                label: "Filtros",
                title: "Filtrar datos",
                queue: "Cola",
                whatsapp: "Cuenta de WhatsApp",
                agent: "Agente",
                all: "Todos",
                clear: "Borrar filtros",
                from: "Desde",
                to: "Hasta"
              },
              title: "Panel CRM de WhatsApp",
              unassigned: "Sin asignar",
              others: "Otros",
              other: "Otro",
              status: {
                open: "Abierto",
                pending: "Pendiente",
                closed: "Cerrado",
                unknown: "Desconocido",
                online: "En línea",
                offline: "Sin conexión"
              },
              range: {
                today: "Hoy",
                yesterday: "Ayer",
                "7d": "7 días",
                "30d": "30 días",
                "90d": "90 días",
                custom: "Personalizado"
              },
              trend: {
                vsPrev: "vs período anterior"
              },
              subtitle: "Aquí tienes una vista en vivo de tu equipo",
              greet: {
                morning: "Buenos días",
                afternoon: "Buenas tardes",
                evening: "Buenas noches",
                night: "Buenas noches"
              },
              role: {
                admin: "Admin",
                supervisor: "Supervisor",
                agent: "Agente"
              },
              pulse: {
                activeChats: "chats activos",
                onlineAgents: "agentes en línea",
                activeNow: "conversaciones activas ahora"
              },
              donut: {
                total: "Tickets totales"
              },
              metric: {
                avgHandle: "Tiempo medio de gestión",
                avgWait: "Tiempo medio de respuesta",
                totalTickets: "Total de tickets",
                uniqueTickets: "Tickets únicos",
                messagesSent: "Mensajes enviados"
              },
              agents: {
                empty: "Sin datos de agentes"
              },
              unit: {
                messages: "mensajes",
                tickets: "tickets"
              },
              charts: {
                perDay: {
                  title: "Atenciones hoy: "
                },
                filters: {
                  button: "Filtrar",
                  startDate: "Fecha de inicio",
                  endDate: "Fecha de fin",
                  periodText: "Período",
                  periodOptions: {
                    input: "Seleccione el período deseado",
                    zero: "No se seleccionó período",
                    three: "Últimos 3",
                    seven: "Últimos 7",
                    fifteen: "Últimos 15",
                    thirty: "Últimos 30",
                    sixty: "Últimos 60",
                    ninety: "Últimos 90"
                  },
                  choosePeriod: "Seleccione el período deseado",
                  selectError: "Seleccione al menos una opción de filtro.",
                  quickRanges: {
                    day: "Día",
                    threeDays: "3 Días",
                    week: "Semana",
                    twoWeeks: "2 Semanas",
                    month: "Mes",
                    threeMonths: "3 Meses",
                    all: "Todo el tiempo"
                  },
                  duedate: "Fecha de vencimiento",
                  filtertype: {
                    title: "Tipo de filtro",
                    valueA: "Filtrar por fecha",
                    valueB: "Filtrar por período",
                    helperText: "Seleccione el período deseado"
                  }
                },
                noData: "No hay datos disponibles",
                dayNames: {
                  full: [
              "Domingo",
              "Lunes",
              "Martes",
              "Miércoles",
              "Jueves",
              "Viernes",
              "Sábado",
            ],
                  short: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]
                },
                titles: {
                  tagsDistribution: "Tickets por etiqueta",
                  statusDistribution: "Nuevos tickets por estado",
                  queueDistribution: "Tickets por cola",
                  userDistribution: "Tickets por usuario",
                  dayDistribution: "Tickets por día de la semana",
                  messagesToday: "Mensajes recibidos hoy",
                  newMessagesReceived: "Nuevos mensajes recibidos"
                }
              },
              cards: {
                attdPendants: "Tickets Pendientes",
                attdHappening: "Tickets Activos",
                attdPerformed: "Tickets Cerrados",
                attdWaiting: "Tickets en Espera",
                leads: "Prospectos",
                mtofService: "Tiempo Promedio de Servicio",
                mtofwaiting: "Tiempo Promedio de Espera",
                total: "Total de Tickets"
              },
              gptAnalytics: {
                title: "Analítica IA",
                refresh: "Actualizar Analítica",
                refreshed: "Analítica actualizada",
                error: "Error al cargar analítica",
                noData: "No hay datos de tickets para analizar",
                resolutionRate: "Tasa de Resolución",
                avgResponseTime: "Tiempo de Respuesta",
                activeTickets: "Activos",
                waitingTickets: "Pendientes",
                overallSentiment: "Análisis de Sentimiento",
                aiInsights: "Insights de IA",
                showMore: "Mostrar Más",
                showLess: "Mostrar Menos",
                topPerformer: "Mejor Desempeño",
                closed: "cerrados",
                queueDistribution: "Distribución por Cola",
                lastUpdated: "Actualizado",
                insights: {
                  highResolution: "¡Excelente tasa de resolución!",
                  lowResolution: "La tasa de resolución necesita mejora",
                  manyPending: "Muchos tickets esperando respuesta",
                  ticketsClosed: "tickets cerrados",
                  slowResponse: "Tiempo de respuesta por encima del promedio",
                  fastResponse: "¡Tiempo de respuesta rápido!"
                }
              },
              kpi: {
                totalTickets: "Total tickets",
                uniqueCustomers: "Clientes únicos",
                messagesReceived: "Mensajes recibidos",
                open: "Abiertos",
                pending: "Pendientes",
                closed: "Cerrados"
              },
              panel: {
                sections: "Tickets por pestaña personalizada",
                sectionsSub: "Distribución por tus pestañas tag-filter personalizadas",
                messagesToday: "Mensajes hoy",
                messagesRange: "Mensajes en {{periodLabel}}",
                ticketsByStatus: "Tickets por estado",
                ticketsByHour: "Tickets por hora",
                generalStats: "Estadísticas generales",
                agents: "Agentes",
                inPeriod: "en el período seleccionado"
              },
              table: {
                section: "Pestaña",
                total: "Total",
                avgHandleTime: "Tiempo medio de gestión",
                closeRate: "Tasa de cierre",
                name: "Nombre",
                calif: "Calificaciones",
                current: "Tickets Activos",
                closed: "Tickets Cerrados",
                timemedia: "Tiempo Promedio de Servicio",
                waiting: "Tiempo Promedio de Espera",
                statuschat: "Estado (Actual)",
                openCalls: "Llamadas abiertas",
                closedCalls: "Llamadas cerradas",
                totalCalls: "Total de llamadas",
                connected: "Conectado",
                disconnected: "Desconectado",
                newCallsByDate: "Nuevas llamadas por fecha",
                status: "Estado",
                tickets: "Tickets",
                avgHandle: "Tiempo de gestión",
                avgWait: "Tiempo de espera",
                openCount: "Abiertos"
              },
              tooltip: {
                ticketsCount: "{{count}} tickets"
              },
              ticketsByHour: {
                title: "Tickets por hora",
                formatButton: "Formato: {{value}}",
                formatOptions: {
                  twelve: "12 h",
                  twentyFour: "24 h"
                },
                chartTypes: {
                  bar: "Columnas",
                  line: "Línea",
                  area: "Área"
                },
                legend: {
                  businessHours: "Horario laboral (9:00-18:00)",
                  outOfHours: "Fuera de horario"
                },
                stats: {
                  title: "Estadísticas por hora",
                  peakHour: "Hora pico",
                  peakHourCount: "{{count}} tickets",
                  businessHours: "Horario laboral",
                  businessHoursSuffix: "del total de tickets",
                  outOfHours: "Fuera de horario",
                  outOfHoursSuffix: "del total de tickets",
                  averagePerHour: "Promedio por hora",
                  averagePerHourSuffix: "tickets por hora"
                },
                seriesName: "Tickets"
              }
            },
            connections: {
              title: "Conexiones",
              hub: {
                statusBadge: {
                  connected: "Conectado",
                  pending: "Conectando",
                  disconnected: "No conectado",
                  loading: "Cargando…"
                },
                instagramNative: {
                  title: "Instagram",
                  description: "Conecta tu cuenta de Instagram directamente — sin página de Facebook.",
                  connect: "Conectar Instagram",
                  reconnect: "Reconectar",
                  disconnect: "Desconectar",
                  connected: "¡Instagram conectado!",
                  connectedSub: "Conectado directamente",
                  idleSub: "Conexión con Instagram Business Login",
                  expiredSub: "Sesión caducada — reconecta"
                }
              },
              toasts: {
                deleted: "Conexión con WhatsApp eliminada con éxito"
              },
              confirmationModal: {
                deleteTitle: "Eliminar",
                deleteMessage: "¿Estás seguro? Esta acción no se puede deshacer.",
                disconnectTitle: "Desconectar",
                disconnectMessage: "¿Estás seguro? Tendrás que escanear el código QR nuevamente."
              },
              buttons: {
                add: "Agregar WhatsApp",
                disconnect: "Desconectar",
                tryAgain: "Intentar nuevamente",
                qrcode: "CÓDIGO QR",
                newQr: "Nuevo CÓDIGO QR",
                connecting: "Conectando"
              },
              toolTips: {
                disconnected: {
                  title: "Error al iniciar sesión en WhatsApp",
                  content: "Asegúrate de que tu teléfono esté conectado a internet y vuelve a intentarlo o solicita un nuevo código QR."
                },
                qrcode: {
                  title: "Esperando lectura del código QR",
                  content: "Haz clic en el botón 'CÓDIGO QR' y escanea el código QR con tu teléfono para iniciar la sesión."
                },
                connected: {
                  title: "Conexión establecida"
                },
                timeout: {
                  title: "Se perdió la conexión con el teléfono",
                  content: "Asegúrate de que tu teléfono esté conectado a internet y WhatsApp esté abierto, o haz clic en 'Desconectar' para obtener un nuevo código QR."
                }
              },
              table: {
                name: "Nombre",
                status: "Estado",
                lastUpdate: "Última actualización",
                default: "Predeterminado",
                actions: "Acciones",
                session: "Sesión"
              }
            },
            rankings: {
              title: "Clasificación",
              eyebrow: "Equipo",
              topSeller: "🔥 Mejor vendedor del mes:",
              topPerformer: "Mejor Desempeño",
              salesLabel: "Ventas",
              table: "Tabla de Ventas",
              period: "Período",
              totalSales: "Ventas Totales",
              rank: "#",
              name: "Nombre",
              sales: "Ventas",
              actions: "Acciones",
              stats: {
                agents: "Agentes"
              },
              empty: {
                title: "Aún no se han registrado ventas",
                adminHelp: "Las ventas son un contador manual — abre Usuarios y edita cada agente para establecer su total de ventas.",
                userHelp: "Una vez que tu administrador registre las ventas del equipo, la clasificación aparecerá aquí.",
                editUsersBtn: "Abrir Usuarios"
              }
            },
            appointments: {
              title: "Citas",
              eyebrow: "Agenda",
              heroSubtitleAdmin: "Gestiona cómo reserva el bot de WhatsApp y qué llega a tu calendario.",
              heroSubtitleOperator: "Mira las reservas que el bot de WhatsApp ha creado.",
              common: {
                cancel: "Cancelar",
                back: "Atrás"
              },
              when: {
                today: "Hoy",
                tomorrow: "Mañana"
              },
              summary: {
                allWeek: "Toda la semana"
              },
              connect: {
                title: "Conectar calendario",
                subtitle: "El bot lee los huecos libres del calendario conectado y crea eventos cuando los clientes reservan por WhatsApp.",
                notConnectedTag: "Calendario no conectado",
                googleBtn: "Conectar Google Calendar",
                microsoftBtn: "Conectar Outlook",
                statusConnected: "Conectado",
                lastSynced: "Sincronización",
                disconnectBtn: "Desconectar",
                confirmDisconnectTitle: "¿Desconectar calendario?",
                confirmDisconnectBody: "El bot dejará de proponer huecos y crear eventos hasta que se reconecte. Las reservas existentes se mantienen.",
                disconnectedToast: "Calendario desconectado"
              },
              workingHours: {
                eyebrow: "Configuración",
                title: "Horario laboral",
                subtitle: "Días y horas en los que el bot puede proponer huecos.",
                daysLabel: "Días en los que el bot puede proponer",
                days: {
                  0: "Dom",
                  1: "Lun",
                  2: "Mar",
                  3: "Mié",
                  4: "Jue",
                  5: "Vie",
                  6: "Sáb"
                },
                startLabel: "Inicio",
                endLabel: "Fin",
                saveBtn: "Guardar",
                savingBtn: "Guardando...",
                savedToast: "Configuración guardada"
              },
              slotConfig: {
                durationLabel: "Duración de cita",
                bufferLabel: "Margen entre citas"
              },
              bookings: {
                eyebrow: "Actividad",
                title: "Reservas",
                upcomingLabel: "próximas",
                totalLabel: "total",
                emptyTitle: "Aún no hay reservas",
                emptyBody: "Aparecerán aquí automáticamente cuando un cliente reserve a través del bot de WhatsApp.",
                cols: {
                  customer: "Cliente",
                  phone: "Teléfono",
                  scheduledAt: "Cuándo",
                  status: "Estado",
                  type: "Tipo",
                  location: "Lugar",
                  actions: ""
                },
                statuses: {
                  pending: "Pendiente",
                  confirmed: "Confirmada",
                  reminderSent: "Recordatorio enviado",
                  completed: "Completada",
                  cancelled: "Cancelada"
                },
                cancelBtn: "Cancelar reserva",
                confirmCancelTitle: "¿Cancelar esta reserva?",
                confirmCancelBody: "El evento del calendario se eliminará y se notificará al cliente.",
                confirmCancelBtn: "Cancelar reserva",
                cancelledToast: "Reserva cancelada"
              },
              errors: {
                connectFailed: "No se pudo abrir la pantalla de consentimiento del proveedor."
              },
              botConfig: {
                eyebrow: "Bot y recordatorios",
                title: "Bot IA y recordatorios",
                subtitle: "Cómo responde el bot en WhatsApp y cuándo salen los recordatorios.",
                botEnabledLabel: "Bot de agenda IA",
                botEnabledOn: "Activado",
                botEnabledOff: "Desactivado",
                languageLabel: "Idioma de las respuestas del bot",
                reminderLeadLabel: "Antelación del recordatorio",
                confirmationTimeoutLabel: "Tiempo de espera de confirmación",
                templateNameLabel: "Nombre de plantilla de WhatsApp",
                templateNameHelp: "Debe coincidir con una plantilla registrada en Meta (p. ej., whapiz_appointment_reminder).",
                signatureLabel: "Firma del negocio",
                saveBtn: "Guardar ajustes del bot",
                savingBtn: "Guardando...",
                savedToast: "Ajustes del bot guardados",
                errors: {
                  templateNameRequired: "El nombre de plantilla es obligatorio — sin él los recordatorios fallarán."
                }
              },
              oauth: {
                successTitle: "Calendario conectado",
                successBody: "Todo listo",
                providerGoogle: "Google Calendar",
                providerMicrosoft: "Microsoft Outlook",
                errorTitle: "Error de conexión",
                errorBody: "Por favor, inténtalo de nuevo"
              }
            },
            internalChat: {
              title: "Chat Interno",
              conversations: "Conversaciones",
              newChat: "Nuevo Chat",
              editChat: "Editar Chat",
              chatTitle: "Título del Chat",
              chatTitlePlaceholder: "Ingrese título del chat...",
              passwordOptional: "Contraseña (Opcional)",
              passwordPlaceholder: "Establecer contraseña para proteger el chat",
              selectParticipants: "Seleccionar Participantes",
              cancel: "Cancelar",
              create: "Crear",
              save: "Guardar",
              confirm: "Confirmar",
              delete: "Eliminar",
              deleteChat: "Eliminar Chat",
              confirmDelete: "¿Está seguro de que desea eliminar este chat?",
              chatCreated: "Chat creado exitosamente",
              chatUpdated: "Chat actualizado exitosamente",
              chatDeleted: "Chat eliminado exitosamente",
              error: "Ocurrió un error",
              titleRequired: "Por favor ingrese un título para el chat",
              usersRequired: "Por favor seleccione al menos un participante",
              selectChat: "Seleccione una conversación",
              selectChatDesc: "Elija un chat de la lista para comenzar a enviar mensajes",
              emptyActions: {
                newChat: "Chat nuevo",
                conversations: "Conversaciones",
                messages: "Mensajes"
              },
              noChats: "No hay conversaciones aún",
              noMessages: "No hay mensajes",
              startConversation: "Iniciar una conversación",
              placeholder: "Escribe un mensaje...",
              download: "Descargar",
              yesterday: "Ayer",
              owner: "Propietario",
              participants: "Participantes",
              showOwner: "Mostrar Propietario",
              showUsers: "Mostrar Participantes",
              passwordRequired: "Contraseña Requerida",
              password: "Contraseña",
              incorrectPassword: "Contraseña incorrecta",
              passwordError: "Error al verificar contraseña",
              chats: "Chats",
              messages: "Mensajes",
              noChat: "Ningún chat seleccionado",
              addMember: "Añadir miembro",
              add: "Añadir",
              memberAdded: "¡Miembro añadido con éxito!",
              close: "Cerrar",
              saving: "Añadiendo...",
              changeColor: "Cambiar color del chat",
              eyebrow: "Equipo",
              stats: {
                conversations: "Conversaciones"
              }
            },
            templates: {
              title: "Plantillas de WhatsApp",
              syncButton: "Sincronizar desde Meta",
              syncFromMeta: "Sincronizar desde Meta",
              sync: "Sincronizar",
              syncing: "Sincronizando...",
              noTemplates: "No se encontraron plantillas. Haga clic en 'Sincronizar desde Meta' para importar.",
              syncNow: "Sincronizar plantillas ahora",
              preview: "Vista previa",
              fillVariables: "Complete las variables",
              lastSynced: "Última sincronización",
              description: "Las plantillas son mensajes preaprobados que se pueden enviar a los clientes después de la ventana de 24 horas. Cree plantillas en Meta Business Manager, luego haga clic en 'Sincronizar desde Meta'.",
              connections: "Conexiones de WhatsApp Business",
              errors: {
                fillAllVariables: "Por favor complete todas las variables",
                sendFailed: "Error al enviar plantilla",
                syncFailed: "Error al sincronizar plantillas"
              },
              success: {
                sent: "Plantilla enviada exitosamente",
                synced: "Plantillas sincronizadas exitosamente"
              },
              buttons: {
                send: "Enviar Plantilla",
                cancel: "Cancelar",
                sync: "Sincronizar desde Meta"
              },
              table: {
                name: "Nombre",
                language: "Idioma",
                connection: "Conexión",
                status: "Estado",
                category: "Categoría",
                active: "Activo",
                preview: "Vista previa"
              },
              categories: {
                utility: "Utilidad",
                marketing: "Marketing",
                authentication: "Autenticación"
              },
              active: "Activo",
              inactive: "Inactivo",
              refresh: "Actualizar",
              stats: {
                total: "Total",
                approved: "Aprobado",
                pending: "Pendiente",
                rejected: "Rechazado"
              }
            },
            gptSettings: {
              title: "Asistente GPT AI",
              subtitle: "Sugerencias impulsadas por IA para tu equipo de soporte",
              enableTitle: "Activar asistente GPT",
              enableDescription: "Las sugerencias de IA aparecerán en las conversaciones",
              status: "Estado",
              apiKeyConfigured: "Clave API configurada",
              apiKeyMissing: "Clave API ausente",
              gptEnabled: "GPT activado",
              gptDisabled: "GPT desactivado",
              currentModel: "Modelo actual",
              apiConfiguration: "Configuración de API",
              apiConfigDesc: "Clave OpenAI y selección de modelo",
              aiModel: "Modelo IA",
              openaiApiKey: "Clave API de OpenAI",
              getApiKey: "Obtén tu clave API en platform.openai.com",
              recommended: "Recomendado",
              responseTone: "Tono de respuesta",
              responseToneDescription: "Elige cómo debe comunicarse la IA",
              advancedSettings: "Configuración avanzada",
              advancedDesc: "Prompt de sistema personalizado",
              customPrompt: "Prompt de sistema personalizado",
              customPromptPlaceholder: "Añade instrucciones personalizadas para la IA...",
              customPromptHint: "Esto se añadirá a todas las respuestas de IA",
              saveSettings: "Guardar configuración",
              saving: "Guardando...",
              saved: "Configuración guardada.",
              loading: "Cargando...",
              showAdvanced: "Mostrar avanzado",
              hideAdvanced: "Ocultar avanzado",
              statusDesc: "Estado actual del asistente de IA"
            },
            whatsappModal: {
              title: {
                add: "Agregar WhatsApp",
                edit: "Editar WhatsApp"
              },
              form: {
                name: "Nombre",
                default: "Predeterminado",
                channel: "Canal",
                channelDescription: "Elija si la conexión funcionará con Baileys (QR) o con la API oficial de Meta.",
                token: "Token de acceso de Meta",
                tokenDescription: "Pegue aquí el token permanente del System User entregado por Meta.",
                defaultDisabled: "Solo las conexiones Baileys pueden definirse como predeterminadas.",
                channelLabelTitle: "Etiqueta del canal",
                channelLabelDescription: "Agregue una etiqueta para identificar este número en los chats (ej: Sitio web, Principal, Soporte)",
                channelLabel: "Etiqueta",
                channelLabelColor: "Color"
              },
              channelOptions: {
                whatsapp: "WhatsApp Web (Baileys)",
                business: "API empresarial de Meta"
              },
              buttons: {
                okAdd: "Agregar",
                okEdit: "Guardar",
                cancel: "Cancelar"
              },
              success: "WhatsApp guardado con éxito."
            },
            qrCode: {
              message: "Lee el código QR para iniciar la sesión"
            },
            contacts: {
              title: "Contactos",
              whatsappUser: "Usuario de WhatsApp",
              toasts: {
                deleted: "Contacto eliminado con éxito"
              },
              searchPlaceholder: "Buscar...",
              confirmationModal: {
                deleteTitle: "Eliminar ",
                importTitlte: "Importar contactos",
                deleteMessage: "¿Estás seguro de que deseas eliminar este contacto? Se perderán todas las conversaciones relacionadas.",
                importMessage: "¿Quieres importar todos los contactos del teléfono?"
              },
              buttons: {
                import: "Importar Contactos",
                add: "Agregar Contacto"
              },
              table: {
                name: "Nombre",
                whatsapp: "WhatsApp",
                email: "Correo electrónico",
                actions: "Acciones",
                phone: "Teléfono"
              }
            },
            contactModal: {
              title: {
                add: "Agregar contacto",
                edit: "Editar contacto"
              },
              form: {
                mainInfo: "Datos del contacto",
                extraInfo: "Información adicional",
                name: "Nombre",
                number: "Número de WhatsApp",
                email: "Correo electrónico",
                extraName: "Nombre del campo",
                extraValue: "Valor",
                disableBot: "Desativar bot de conversa"
              },
              buttons: {
                addExtraInfo: "Agregar información",
                okAdd: "Agregar",
                okEdit: "Guardar",
                cancel: "Cancelar"
              },
              success: "Contacto guardado con éxito."
            },
            aiDashboard: {
              title: "Panel de IA",
              refresh: "Actualizar",
              noData: "Sin datos disponibles",
              allAgents: "Todos los agentes",
              daysCount: "{{count}} días",
              singleDay: "día",
              multiDay: "días",
              kpi: {
                totalConversations: "Total chats",
                open: "Abiertos",
                pending: "Pendientes",
                closed: "Cerrados",
                responseTime: "Tiempo de respuesta",
                satisfaction: "Satisfacción",
                resolvedPct: "{{pct}}% resuelto",
                outOfFive: "de 5.0"
              },
              subtitle: {
                chats: "{{count}} chats",
                activeAgents: "{{count}} agentes activos"
              },
              quickInsights: {
                loadSubtitle: "{{score}}/100 carga",
                resolutionSubtitle: "{{closed}} de {{total}}",
                avgPerTicket: "media por ticket",
                noStats: "Sin datos",
                customerSatisfaction: "Satisfacción del cliente"
              },
              units: {
                minuteAbbr: "m",
                hourAbbr: "h",
                dayAbbr: "d"
              },
              tabs: {
                overview: "Resumen",
                agentPerformance: "Rendimiento de Agentes",
                keyIssues: "Problemas Clave",
                sentimentTrends: "Tendencias de Sentimiento",
                salesInsights: "Análisis de Ventas",
                learning: "Aprendizaje"
              },
              filters: {
                dateRange: "Rango de Fechas",
                last7days: "Últimos 7 días",
                last14days: "Últimos 14 días",
                last30days: "Últimos 30 días",
                last90days: "Últimos 90 días"
              },
              overview: {
                totalConversations: "Total de Conversaciones",
                avgResponseTime: "Tiempo de Respuesta Promedio",
                resolutionRate: "Tasa de Resolución",
                satisfaction: "Satisfacción del Cliente",
                aiPerformance: "Rendimiento de IA",
                suggestionsUsed: "Sugerencias de IA Usadas",
                aiAccuracy: "Precisión de IA",
                activeAgents: "Agentes Activos",
                pendingTickets: "Tickets Pendientes",
                quickInsights: "Insights Rápidos",
                workload: "Carga de trabajo",
                openTickets: "Tickets Abiertos",
                ticketsPerAgent: "Tickets por Agente",
                workloadLevel: "Nivel de Carga",
                systemStatus: "Estado del Sistema",
                closedToday: "Cerrados Hoy"
              },
              status: {
                normal: "Normal",
                moderate: "Carga Moderada",
                highLoad: "Carga Alta"
              },
              insights: {
                peakHours: "Horas Pico",
                peakHoursDesc: "La mayoría de conversaciones ocurren entre 10AM-2PM",
                topPerformer: "Mejor Rendimiento",
                topPerformerDesc: "Basado en tiempo de respuesta y tasa de resolución"
              },
              agentPerformance: {
                selectAgent: "Seleccionar Agente",
                allAgents: "Todos los Agentes",
                responseTime: "Tiempo de Respuesta Promedio",
                ticketsHandled: "Tickets Manejados",
                qualityScore: "Puntuación de Calidad",
                detailedAnalysis: "Análisis Detallado",
                workload: "Carga de Trabajo",
                politenessScore: "Puntuación de Cortesía",
                aiRecommendations: "Recomendaciones de IA",
                firstResponse: "Primera Respuesta",
                missedMessages: "Mensajes Perdidos",
                ticketsResolved: "Tickets Resueltos",
                sentimentTrend: "Tendencia de Sentimiento",
                confusionCases: "Casos de Confusión",
                recoveryRate: "Tasa de Recuperación",
                resolutionRate: "Tasa de Resolución",
                improving: "Mejorando",
                declining: "Declinando",
                stable: "Estable"
              },
              keyIssues: {
                title: "Problemas Detectados",
                subtitle: "Problemas identificados en conversaciones con clientes",
                occurrences: "ocurrencias",
                lastSeen: "Visto por última vez",
                noIssues: "No se detectaron problemas críticos",
                unknownIssue: "Problema Desconocido",
                ticketsAffected: "tickets afectados",
                patterns: "Patrones comunes",
                recommendations: "Recomendaciones"
              },
              sentiment: {
                positive: "Positivo",
                neutral: "Neutral",
                negative: "Negativo",
                trends: "Tendencias de Sentimiento",
                trendsDescription: "Rastree el sentimiento del cliente para identificar patrones",
                trend: "Tendencia",
                messagesAnalyzed: "Mensajes Analizados",
                topPositiveKeywords: "Palabras Clave Positivas",
                topNegativeKeywords: "Palabras Clave Negativas",
                improving: "Mejorando",
                declining: "Declinando",
                stable: "Estable"
              },
              salesInsights: {
                title: "Oportunidades de Venta",
                upsellOpportunities: "Oportunidades de Upsell",
                upsellDescription: "Conversaciones con potencial de ventas adicionales",
                conversionRate: "Tasa de Conversión",
                conversionDescription: "Leads convertidos en reservas exitosas",
                totalOpportunities: "Total de Oportunidades",
                revenuePotential: "Potencial de Ingresos",
                upsellCrossSell: "Upsell + Venta Cruzada",
                opportunitiesByType: "Oportunidades por Tipo",
                upsell: "Upsell",
                crossSell: "Venta Cruzada",
                newProduct: "Nuevo Producto",
                topProductsMentioned: "Productos Más Mencionados",
                noProductsDetected: "No se detectaron productos",
                recentOpportunities: "Oportunidades Recientes"
              }
            },
            aiWorkforce: {
              title: "Personal de IA",
              refresh: "Actualizar",
              enabled: "Activo",
              disabled: "Desactivado",
              stats: {
                activeAgents: "Agentes Activos",
                knowledgeItems: "Elementos de Conocimiento",
                businessRules: "Reglas de Negocio",
                actionsToday: "Acciones Hoy"
              },
              tabs: {
                agents: "Agentes de IA",
                knowledge: "Base de Conocimientos",
                rules: "Reglas de Negocio",
                logs: "Registro de Acciones"
              },
              agents: {
                title: "Configuración de Agentes de IA",
                addAgent: "Agregar Agente",
                createTitle: "Crear Agente",
                editTitle: "Editar Agente",
                name: "Nombre del Agente",
                role: "Rol",
                model: "Modelo GPT",
                temperature: "Temperatura",
                maxTokens: "Máx. Tokens",
                systemPrompt: "Prompt del Sistema (Opcional)",
                agentEnabled: "Agente Habilitado",
                test: "Probar",
                testAgent: "Probar Agente",
                runningTest: "Ejecutando prueba...",
                testSuccess: "Prueba completada exitosamente",
                result: "Resultado",
                noAgents: "No hay Agentes de IA",
                noAgentsDesc: "Crea tu primer agente de IA para automatizar flujos de trabajo",
                deleteConfirm: "¿Estás seguro de que deseas eliminar este agente?",
                created: "Agente creado exitosamente",
                updated: "Agente actualizado exitosamente",
                deleted: "Agente eliminado",
                roles: {
                  conversation: "Agente de Conversación",
                  queue_manager: "Gestor de Colas",
                  process_finisher: "Finalizador de Procesos",
                  offer_matcher: "Emparejador de Ofertas",
                  pricing_calculator: "Calculadora de Precios",
                  promotion_engine: "Motor de Promociones",
                  supervisor: "Agente Supervisor",
                  business_intelligence: "Inteligencia de Negocios",
                  scheduling_manager: "Gestor de Horarios",
                  notification_engine: "Motor de Notificaciones"
                },
                models: {
                  gpt4o: "GPT-4o (Recomendado)",
                  gpt4turbo: "GPT-4 Turbo",
                  gpt35turbo: "GPT-3.5 Turbo (Más Rápido)"
                },
                temperatureLabels: {
                  precise: "Preciso",
                  creative: "Creativo"
                }
              },
              knowledge: {
                title: "Base de Conocimientos",
                add: "Agregar",
                createTitle: "Agregar Conocimiento",
                editTitle: "Editar Conocimiento",
                titleField: "Título",
                content: "Contenido",
                type: "Tipo",
                active: "Activo",
                inactive: "Inactivo",
                updated: "Actualizado",
                search: "Buscar...",
                noKnowledge: "No hay Entradas de Conocimiento",
                noKnowledgeDesc: "Agrega productos, FAQs y políticas para referencia de la IA",
                deleteConfirm: "¿Eliminar esta entrada de conocimiento?",
                created: "Conocimiento creado",
                updatedMsg: "Conocimiento actualizado",
                deleted: "Conocimiento eliminado",
                types: {
                  product: "Producto",
                  faq: "FAQ",
                  policy: "Política",
                  general: "General",
                  supplier: "Proveedor",
                  destination: "Destino"
                }
              },
              rules: {
                title: "Reglas de Negocio",
                addRule: "Agregar Regla",
                createTitle: "Agregar Regla",
                editTitle: "Editar Regla",
                name: "Nombre de la Regla",
                type: "Tipo",
                description: "Descripción",
                priority: "Prioridad",
                conditions: "Condiciones (JSON)",
                actions: "Acciones (JSON)",
                active: "Activo",
                inactive: "Inactivo",
                noRules: "No hay Reglas de Negocio",
                noRulesDesc: "Configura reglas de precios, enrutamiento y escalamiento",
                deleteConfirm: "¿Eliminar esta regla?",
                created: "Regla creada",
                updated: "Regla actualizada",
                deleted: "Regla eliminada",
                types: {
                  pricing: "Precios",
                  promotion: "Promoción",
                  routing: "Enrutamiento",
                  escalation: "Escalamiento",
                  commission: "Comisión",
                  general: "General"
                },
                keywordsHelper: "ej. cancelar, parar, gerente"
              },
              logs: {
                title: "Registro de Acciones de IA",
                noLogs: "No hay Registros",
                noLogsDesc: "Las acciones de la IA aparecerán aquí",
                ticket: "Ticket"
              },
              common: {
                save: "Guardar",
                cancel: "Cancelar",
                close: "Cerrar",
                all: "Todos",
                name: "Nombre",
                status: "Estado",
                actions: "Acciones",
                edit: "Editar",
                delete: "Eliminar"
              }
            },
            offers: {
              title: "Catálogo de Ofertas",
              newOffer: "Nueva Oferta",
              searchPlaceholder: "Buscar ofertas...",
              stats: {
                total: "Total de Ofertas",
                active: "Activas",
                featured: "Destacadas"
              },
              source: {
                label: "Fuente",
                all: "Todas las Fuentes",
                internal: "Interno",
                external: "Raviv API",
                offerDetails: "Detalles de Oferta"
              },
              table: {
                offer: "Oferta",
                destination: "Destino",
                duration: "Duración",
                price: "Precio",
                status: "Estado",
                featured: "Destacada",
                actions: "Acciones",
                nights: "noches",
                active: "Activo",
                inactive: "Inactivo"
              },
              modal: {
                createTitle: "Crear Nueva Oferta",
                editTitle: "Editar Oferta",
                sections: {
                  basicInfo: "Información Básica",
                  destination: "Destino",
                  datesDuration: "Fechas y Duración",
                  pricing: "Precios",
                  accommodation: "Alojamiento",
                  flight: "Vuelo (opcional)",
                  images: "Imágenes",
                  status: "Estado"
                },
                fields: {
                  title: "Título de la Oferta",
                  titlePlaceholder: "ej., Escapada Romántica a París",
                  type: "Tipo",
                  description: "Descripción",
                  descriptionPlaceholder: "Describe qué hace especial esta oferta...",
                  destination: "Destino",
                  destinationPlaceholder: "ej., París",
                  country: "País",
                  countryPlaceholder: "ej., Francia",
                  validFrom: "Válido Desde",
                  validTo: "Válido Hasta",
                  days: "Días",
                  nights: "Noches",
                  basePrice: "Precio Base",
                  currency: "Moneda",
                  childPrice: "Precio Niño",
                  markup: "Margen %",
                  hotelName: "Nombre del Hotel",
                  stars: "Estrellas",
                  board: "Régimen",
                  airline: "Aerolínea",
                  departureCity: "Ciudad de Salida",
                  compositionPricing: "Precios por composición (Total por grupo)",
                  compositionPricingHint: "Establece precios totales para cada composición familiar. Deja vacío para calcular: precio base × viajeros.",
                  pricingCouple: "Pareja",
                  pricingCouple1Child: "Pareja + 1 Niño",
                  pricingCouple2Children: "Pareja + 2 Niños",
                  pricingCouple3Children: "Pareja + 3 Niños",
                  pricingSingle: "Individual",
                  pricing3Adults: "3 Adultos",
                  pricing3Adults1Child: "3 Adultos + 1 Niño",
                  pricing3Adults2Children: "3 Adultos + 2 Niños"
                },
                boardTypes: {
                  none: "Ninguno",
                  roomOnly: "Solo Habitación",
                  bedBreakfast: "Desayuno Incluido",
                  halfBoard: "Media Pensión",
                  fullBoard: "Pensión Completa",
                  allInclusive: "Todo Incluido"
                },
                types: {
                  package: "Paquete",
                  flight: "Vuelo",
                  hotel: "Hotel",
                  tour: "Tour",
                  cruise: "Crucero",
                  custom: "Personalizado"
                },
                active: "Activo",
                activeDescription: "Visible para clientes",
                featured: "Destacada",
                featuredDescription: "Resaltada en listados",
                cancel: "Cancelar",
                create: "Crear Oferta",
                save: "Guardar Cambios"
              },
              images: {
                title: "Añade imágenes para mostrar esta oferta",
                hint: "Las imágenes de calidad aumentan las reservas un 40%",
                uploadNew: "Subir Nueva",
                browseLibrary: "Explorar Biblioteca",
                uploading: "Subiendo imágenes..."
              },
              mediaBrowser: {
                title: "Seleccionar de la Biblioteca",
                selected: "imagen(es) seleccionada(s)",
                clickToSelect: "Haz clic en las imágenes para seleccionarlas",
                loading: "Cargando archivos multimedia...",
                noFiles: "No se encontraron archivos",
                noFilesHint: "Sube algunas imágenes primero",
                cancel: "Cancelar",
                addImages: "Añadir"
              },
              empty: {
                title: "Aún no hay ofertas",
                description: "Crea tu primera oferta para atraer clientes",
                createFirst: "Crear Primera Oferta"
              },
              delete: {
                title: "Eliminar Oferta",
                confirm: "¿Estás seguro de que deseas eliminar",
                warning: "Esta acción no se puede deshacer."
              },
              toast: {
                created: "¡Oferta creada con éxito!",
                updated: "¡Oferta actualizada con éxito!",
                deleted: "Oferta eliminada"
              }
            },
            queueModal: {
              title: {
                add: "Agregar fila",
                edit: "Editar fila"
              },
              form: {
                name: "Nombre",
                color: "Color",
                greetingMessage: "Mensaje de bienvenida",
                complationMessage: "Mensaje de conclusión",
                outOfHoursMessage: "Mensaje fuera del horario",
                ratingMessage: "Mensaje de calificación",
                transferMessage: "Mensaje de transferencia",
                token: "Token"
              },
              buttons: {
                okAdd: "Agregar",
                okEdit: "Guardar",
                cancel: "Cancelar",
                attach: "Adjuntar archivo",
                edit: "Editar",
                duplicate: "Duplicar"
              },
              serviceHours: {
                dayWeek: "Día de la semana",
                startTimeA: "Hora de inicio - Turno A",
                endTimeA: "Hora de finalización - Turno A",
                startTimeB: "Hora de inicio - Turno B",
                endTimeB: "Hora de finalización - Turno B",
                monday: "Lunes",
                tuesday: "Martes",
                wednesday: "Miércoles",
                thursday: "Jueves",
                friday: "Viernes",
                saturday: "Sábado",
                sunday: "Domingo"
              },
              options: {
                title: "Opciones",
                notDefined: "Título no definido",
                message: "Ingrese el texto de la opción",
                note: {
                  title: "Agregue opciones para construir un chatbot",
                  content: "Si hay solo una opción, se seleccionará automáticamente, activando al bot para responder con el mensaje de la opción y continuar"
                },
                addOpts: "Agregar opciones",
                attendant: "Transferir a:"
              },
              confirmationModal: {
                deleteTitle: "Eliminar archivo adjunto",
                deleteMessage: "¿Está seguro de que desea eliminar este archivo adjunto?",
                deleteOptionTitle: "Eliminar pregunta del bot",
                deleteOptionMessage: "¿Está seguro de que desea eliminar esta pregunta del bot? Esta acción no se puede deshacer."
              }
            },
            userModal: {
              title: {
                add: "Agregar usuario",
                edit: "Editar usuario"
              },
              form: {
                name: "Nombre",
                email: "Correo electrónico",
                password: "Contraseña",
                profile: "Perfil",
                sales: "Ventas",
                salesHelp: "Contador manual mostrado en la clasificación.",
                currency: "Moneda"
              },
              buttons: {
                okAdd: "Agregar",
                okEdit: "Guardar",
                save: "Guardar",
                cancel: "Cancelar"
              },
              success: "Usuario guardado con éxito."
            },
            scheduleModal: {
              title: {
                add: "Nuevo Agendamiento",
                edit: "Editar Agendamiento",
                error: "Error de envío",
                message: "Mensaje"
              },
              form: {
                body: "Mensaje",
                contact: "Contacto",
                sendAt: "Fecha de Agendamiento",
                sentAt: "Fecha de Envío",
                saveMessage: "Guardar mensaje en el ticket"
              },
              buttons: {
                okAdd: "Agregar",
                okEdit: "Guardar",
                cancel: "Cancelar"
              },
              success: "Agendamiento guardado con éxito."
            },
            tagModal: {
              title: {
                add: "Nueva Etiqueta",
                edit: "Editar Etiqueta",
                addKanban: "Nueva Columna",
                editKanban: "Editar Columna"
              },
              form: {
                name: "Nombre",
                color: "Color",
                kanban: "Kanban"
              },
              buttons: {
                okAdd: "Agregar",
                okEdit: "Guardar",
                cancel: "Cancelar"
              },
              success: "Etiqueta guardada con éxito.",
              successKanban: "Columna guardada con éxito."
            },
            chat: {
              noTicketMessage: "Selecciona un ticket para empezar a conversar.",
              welcomeBack: "Bienvenido de nuevo",
              tip1Title: "Elige una conversación",
              tip1Text: "Haz clic en cualquier chat de la lista para empezar a responder a un cliente",
              tip2Title: "Respuestas rápidas",
              tip2Text: "Usa respuestas rápidas predefinidas para ahorrar tiempo en cada conversación",
              tip3Title: "Sé el primero en responder",
              tip3Text: "Responder en 7 minutos aumenta la satisfacción del cliente en un 32%"
            },
            uploads: {
              titles: {
                titleUploadMsgDragDrop: "ARRASTRA Y SUELTA ARCHIVOS EN EL CAMPO ABAJO",
                titleFileList: "Lista de archivo(s)"
              }
            },
            ticketsManager: {
              buttons: {
                newTicket: "Nuevo"
              }
            },
            ticketsQueueSelect: {
              placeholder: "Colas"
            },
            tickets: {
              title: "Tickets de Chat",
              toasts: {
                deleted: "La atención que estabas siguiendo fue eliminada."
              },
              notification: {
                message: "Mensaje de"
              },
              tabs: {
                open: {
                  title: "Abiertas"
                },
                closed: {
                  title: "Resueltos"
                },
                groups: {
                  title: "Grupos"
                },
                search: {
                  title: "Búsqueda"
                }
              },
              search: {
                placeholder: "Buscar por nombre, teléfono o mensaje..."
              },
              buttons: {
                showAll: "Todos"
              }
            },
            ticketsList: {
              pendingHeader: "Pendientes",
              assignedHeader: "En progreso",
              noTicketsTitle: "¡No hay nada aquí!",
              noTicketsMessage: "No se encontraron tickets con este estado o término de búsqueda",
              noQueue: "Sin cola",
              buttons: {
                accept: "Aceptar",
                close: "Cerrar"
              },
              items: {
                tags: "Etiquetas"
              }
            },
            quickMessages: {
              title: "Respuestas Rápidas",
              buttons: {
                add: "Nueva Respuesta",
                save: "Guardar"
              },
              table: {
                shortcut: "Atajo",
                message: "Mensaje",
                actions: "Acciones"
              },
              dialog: {
                shortcode: "Atajo",
                message: "Respuesta"
              },
              toasts: {
                deleted: "Respuesta rápida eliminada exitosamente."
              }
            },
            transferTicketModal: {
              title: "Transferir Ticket",
              fieldLabel: "Escribe para buscar usuarios",
              fieldQueueLabel: "Transferir a cola",
              fieldQueuePlaceholder: "Selecciona una cola",
              noOptions: "Ningún usuario encontrado con ese nombre",
              buttons: {
                ok: "Transferir",
                cancel: "Cancelar"
              }
            },
            forwardMessageModal: {
              dialog: {
                title: "Reenviar mensaje a:",
                button: "Enviar",
                sending: "Enviando",
                error: "Seleccione mensajes para reenviar"
              }
            },
            newTicketModal: {
              title: "Crear Ticket",
              fieldLabel: "Escribe para buscar el contacto",
              add: "Agregar",
              buttons: {
                ok: "Guardar",
                cancel: "Cancelar"
              }
            },
            mainDrawer: {
              listItems: {
                aiOs: "AI-OS — el Cerebro",
                dashboard: "Tablero",
                connections: "Conexiones",
                tickets: "Atenciones",
                voiceIntelligence: "Voice Intelligence",
                appointments: "Citas",
                quickMessages: "Respuestas Rápidas",
                contacts: "Contactos",
                queues: "Filas y Chatbot",
                tags: "Etiquetas",
                toDoList: "Lista de Tareas",
                administration: "Administración",
                service: "Atención",
                users: "Usuarios",
                settings: "Configuraciones",
                helps: "Ayuda",
                about: "Líderes de ventas",
                messagesAPI: "API",
                schedules: "Tareas programadas",
                files: "Archivos",
                campaigns: "Campañas",
                annoucements: "Anuncios",
                chats: "Chat Interno",
                financeiro: "Financiero",
                logout: "Cerrar sesión",
                management: "Gerencia",
                kanban: "Kanban",
                whatsappBackups: "Copias de seguridad WhatsApp",
                archivo: "Archivo",
                aiDashboard: "Panel de IA",
                aiSettings: "Configuración de IA",
                aiWorkforce: "AI Workforce",
                teams: "Equipos",
                offers: "Catálogo de Ofertas",
                pipelines: "Flujos de Procesamiento",
                billing: "Facturación"
              },
              role: {
                administrator: "Administrador",
                supervisor: "Supervisor",
                agent: "Agente"
              },
              workspace: {
                admin: "Espacio de trabajo de administrador",
                supervisor: "Espacio de trabajo de supervisor",
                default: "Espacio de trabajo"
              },
              appBar: {
                backToAdmin: "Volver al admin",
                i18n: {
                  language: "Español",
                  language_short: "ES"
                },
                greetings: {
                  one: "Hola",
                  two: "Bienvenido a"
                },
                user: {
                  profile: "Perfil",
                  darkmode: "Modo oscuro",
                  lightmode: "Modo claro",
                  language: "Seleccionar idioma",
                  logout: "Cerrar sesión"
                }
              }
            },
            messagesAPI: {
              title: "API",
              textMessage: {
                number: "Número",
                body: "Mensaje",
                token: "Token registrado"
              },
              mediaMessage: {
                number: "Número",
                body: "Nombre del archivo",
                media: "Archivo",
                token: "Token registrado"
              }
            },
            notifications: {
              noTickets: "Ninguna notificación."
            },
            toDoList: {
              confirmDelete: "¿Eliminar \"{{title}}\"? No se puede deshacer.",
              title: "Gestión de Tareas",
              tasksCompleted: "tareas completadas",
              reminder: "Recordatorio",
              dueIn: "vence en",
              hours: "horas",
              reminderEnabled: "Recordatorio activado",
              stats: {
                total: "Total",
                active: "Activas",
                completed: "Completadas",
                overdue: "Vencidas"
              },
              tabs: {
                all: "Todas",
                active: "Activas",
                completed: "Completadas",
                overdue: "Vencidas"
              },
              filters: {
                allPriorities: "Todas las Prioridades",
                allTypes: "Todos los Tipos"
              },
              sort: {
                newest: "Más Recientes",
                priority: "Por Prioridad",
                dueDate: "Por Fecha",
                title: "Por Título"
              },
              priority: {
                high: "Alta",
                medium: "Media",
                low: "Baja",
                urgent: "Urgente"
              },
              dates: {
                today: "Hoy",
                tomorrow: "Mañana"
              },
              form: {
                label: "Crear nueva tarea",
                placeholder: "Ingrese tarea",
                title: "Título",
                description: "Descripción",
                priority: "Prioridad",
                dueDate: "Fecha Límite",
                reminderOn: "🔔 Recordatorio ACTIVO (24h antes)",
                reminderOff: "🔕 Activar Recordatorio",
                category: "Categoría",
                noCategory: "Sin Categoría",
                reminderDate: "Fecha de Recordatorio",
                visibility: "Visibilidad",
                assignTo: "Asignar a",
                myself: "A mí",
                team: "Equipo",
                selectTeam: "Seleccionar Equipo",
                queue: "Cola",
                selectQueue: "Seleccionar Cola",
                shareWith: "Compartir con",
                selectUsers: "Seleccionar Usuarios"
              },
              table: {
                task: "Tarea",
                date: "Fecha de Creación",
                actions: "Acciones"
              },
              buttons: {
                add: "Agregar Tarea",
                save: "Guardar",
                cancel: "Cancelar",
                newTask: "Nueva Tarea",
                createFirst: "Crea Tu Primera Tarea"
              },
              dialog: {
                newTask: "Nueva Tarea",
                editTask: "Editar Tarea"
              },
              actions: {
                markComplete: "Marcar como Completada",
                markIncomplete: "Marcar como Incompleta",
                edit: "Editar",
                delete: "Eliminar",
                refresh: "Actualizar",
                complete: "Completar",
                reopen: "Reabrir"
              },
              messages: {
                created: "Tarea creada exitosamente",
                updated: "Tarea actualizada exitosamente",
                deleted: "Tarea eliminada",
                completed: "¡Completado!"
              },
              errors: {
                titleRequired: "Se requiere título de la tarea"
              },
              empty: {
                noTasks: "No hay tareas aún. ¡Crea la primera!",
                noCompleted: "No hay tareas completadas aún",
                noOverdue: "¡Excelente! No hay tareas vencidas"
              },
              status: {
                pending: "Pendiente",
                in_progress: "En Progreso",
                completed: "Completada",
                cancelled: "Cancelada"
              },
              visibility: {
                personal: "Personal",
                personalDesc: "Solo tú puedes ver",
                shared: "Compartida",
                sharedDesc: "Compartir con usuarios",
                team: "Equipo",
                teamDesc: "Todo el equipo puede ver",
                queue: "Cola",
                queueDesc: "Todos en la cola pueden ver"
              },
              noAssignee: "Sin asignar",
              notifications: {
                newTaskAssigned: "Nueva tarea asignada"
              },
              comments: {
                title: "Comentarios",
                noComments: "Aún no hay comentarios",
                placeholder: "Escribe un comentario...",
                added: "Comentario añadido",
                deleted: "Comentario eliminado",
                addFailed: "Error al añadir comentario",
                deleteFailed: "Error al eliminar comentario",
                delete: "Eliminar comentario",
                unknownUser: "Usuario desconocido"
              }
            },
            kanban: {
              title: "Kanban",
              searchPlaceholder: "Búsqueda",
              subMenus: {
                list: "Panel",
                tags: "Lanes"
              }
            },
            tagsKanban: {
              title: "Lanes",
              laneDefault: "En abierto",
              confirmationModal: {
                deleteTitle: "¿Estás seguro de que quieres eliminar esta Lane?",
                deleteMessage: "Esta acción no se puede deshacer."
              },
              table: {
                name: "Nombre",
                color: "Color",
                tickets: "Tickets",
                actions: "Acciones"
              },
              buttons: {
                add: "Nueva Lane"
              },
              toasts: {
                deleted: "Lane eliminada con éxito."
              }
            },
            contactLists: {
              title: "Listas de Contactos",
              table: {
                name: "Nombre",
                contacts: "Contactos",
                actions: "Acciones"
              },
              buttons: {
                add: "Nueva Lista"
              },
              dialog: {
                name: "Nombre",
                company: "Empresa",
                okEdit: "Editar",
                okAdd: "Agregar",
                add: "Agregar",
                edit: "Editar",
                cancel: "Cancelar"
              },
              confirmationModal: {
                deleteTitle: "Eliminar",
                deleteMessage: "Esta acción no se puede deshacer."
              },
              toasts: {
                deleted: "Registro eliminado",
                created: "Registro creado"
              }
            },
            files: {
              title: "Catálogo de Archivos",
              preview: "Vista previa del archivo",
              notImage: "Este archivo no es una imagen",
              download: "Descargar archivo",
              table: {
                name: "Nombre",
                contacts: "Contactos",
                actions: "Acciones",
                view: "Ver Archivo"
              },
              toasts: {
                deleted: "¡Archivo eliminado con éxito!",
                deletedAll: "¡Todos los archivos eliminados con éxito!"
              },
              buttons: {
                add: "Agregar",
                deleteAll: "Eliminar Todo"
              },
              confirmationModal: {
                deleteTitle: "Eliminar",
                deleteAllTitle: "Eliminar Todo",
                deleteMessage: "¿Estás seguro de que quieres eliminar este archivo?",
                deleteAllMessage: "¿Estás seguro de que quieres eliminar todos los archivos?"
              }
            },
            contactListItems: {
              title: "Contactos",
              searchPlaceholder: "Buscar",
              buttons: {
                add: "Nuevo",
                lists: "Listas",
                import: "Importar"
              },
              dialog: {
                name: "Nombre",
                number: "Número",
                whatsapp: "Whatsapp",
                email: "Correo electrónico",
                okEdit: "Editar",
                okAdd: "Agregar",
                add: "Agregar",
                edit: "Editar",
                cancel: "Cancelar"
              },
              table: {
                name: "Nombre",
                number: "Número",
                whatsapp: "Whatsapp",
                email: "Correo electrónico",
                actions: "Acciones"
              },
              confirmationModal: {
                deleteTitle: "Eliminar",
                deleteMessage: "Esta acción no se puede deshacer.",
                importMessage: "¿Desea importar los contactos de esta hoja de cálculo?",
                importTitlte: "Importar"
              },
              toasts: {
                deleted: "Registro eliminado"
              }
            },
            campaigns: {
              title: "Campañas de WhatsApp",
              searchPlaceholder: "Buscar campañas...",
              buttons: {
                add: "Nueva Campaña",
                addRecipients: "Agregar Destinatarios",
                send: "Enviar Campaña",
                edit: "Editar",
                delete: "Eliminar",
                viewStats: "Ver Estadísticas",
                refresh: "Actualizar",
                contactLists: "Listas de Contactos",
                pause: "Pausar",
                resume: "Reanudar",
                stop: "Detener",
                restart: "Reiniciar"
              },
              table: {
                name: "Nombre",
                type: "Tipo",
                template: "Plantilla",
                whatsapp: "Conexión",
                contactList: "Lista de Contactos",
                status: "Estado",
                recipients: "Destinatarios",
                progress: "Progreso",
                scheduledAt: "Programado",
                completedAt: "Completada",
                createdAt: "Creada",
                confirmation: "Confirmación",
                actions: "Acciones",
                sentAt: "Enviado"
              },
              status: {
                draft: "Borrador",
                scheduled: "Programada",
                sending: "Enviando",
                paused: "Pausada",
                completed: "Completada",
                cancelled: "Cancelada",
                failed: "Fallida"
              },
              types: {
                marketing: "Marketing",
                service_update: "Actualización de Servicio"
              },
              dialog: {
                new: "Crear Nueva Campaña",
                update: "Editar Campaña",
                readonly: "Solo Lectura",
                form: {
                  name: "Nombre de la Campaña",
                  type: "Tipo",
                  template: "Plantilla",
                  language: "Idioma",
                  whatsapp: "Conexión WhatsApp",
                  scheduledAt: "Programar Envío (opcional)",
                  scheduledAtHint: "Dejar vacío para envío manual",
                  message1: "Mensaje 1",
                  message2: "Mensaje 2",
                  message3: "Mensaje 3",
                  message4: "Mensaje 4",
                  message5: "Mensaje 5",
                  confirmationMessage1: "Mensaje de Confirmación 1",
                  confirmationMessage2: "Mensaje de Confirmación 2",
                  confirmationMessage3: "Mensaje de Confirmación 3",
                  confirmationMessage4: "Mensaje de Confirmación 4",
                  confirmationMessage5: "Mensaje de Confirmación 5",
                  messagePlaceholder: "Contenido del mensaje",
                  status: "Estado",
                  confirmation: "Confirmación",
                  contactList: "Lista de Contacto"
                },
                buttons: {
                  add: "Crear",
                  edit: "Guardar",
                  okadd: "Ok",
                  cancel: "Cancelar",
                  restart: "Reiniciar Disparos",
                  close: "Cerrar",
                  attach: "Adjuntar Archivo",
                  import: "Importar"
                }
              },
              recipients: {
                title: "Agregar Destinatarios",
                tabs: {
                  csv: "Subir CSV",
                  manual: "Entrada Manual",
                  contacts: "Desde Contactos"
                },
                csv: {
                  description: "Sube un archivo CSV con columnas: phone, name (opcional), var1, var2, var3 (para variables de plantilla)",
                  upload: "Clic para subir archivo CSV",
                  preview: "Vista previa",
                  rows: "filas",
                  moreRows: "y {{count}} filas más",
                  variables: "Variables"
                },
                manual: {
                  description: "Ingresa números de teléfono (uno por línea, o separados por comas). Los números deben estar en formato internacional (ej: 972501234567).",
                  placeholder: "972501234567\n972502345678\n972503456789",
                  numbersEntered: "{{count}} números ingresados"
                },
                contacts: {
                  search: "Buscar contactos...",
                  selectAll: "Seleccionar Todos",
                  selected: "{{count}} seleccionados",
                  noContacts: "No se encontraron contactos"
                },
                importResult: {
                  title: "Importación completada:",
                  imported: "Importados",
                  duplicates: "Duplicados",
                  invalid: "Inválidos",
                  matched: "Contactos coincidentes"
                }
              },
              details: {
                stats: {
                  total: "Total",
                  pending: "Pendientes",
                  sent: "Enviados",
                  delivered: "Entregados",
                  read: "Leídos",
                  failed: "Fallidos"
                },
                info: {
                  template: "Plantilla",
                  language: "Idioma",
                  whatsapp: "WhatsApp",
                  created: "Creada"
                },
                tabs: {
                  all: "Todos los Destinatarios",
                  failed: "Fallidos"
                },
                noRecipients: "No hay destinatarios aún. Importa desde CSV para agregar.",
                error: "Error"
              },
              confirmationModal: {
                deleteTitle: "Eliminar Campaña",
                deleteMessage: "¿Estás seguro de que quieres eliminar \"{{name}}\"? Esta acción no se puede deshacer.",
                sendTitle: "Enviar Campaña",
                sendMessage: "¿Enviar campaña \"{{name}}\" a {{count}} destinatarios?"
              },
              toasts: {
                success: "Operación realizada con éxito",
                created: "Campaña creada exitosamente",
                updated: "Campaña actualizada exitosamente",
                cancel: "Campaña cancelada",
                restart: "Campaña reiniciada",
                deleted: "Campaña eliminada exitosamente",
                sending: "¡Envío de campaña iniciado!",
                importSuccess: "{{count}} destinatarios importados",
                noRecipients: "Por favor agrega destinatarios antes de enviar",
                fillRequired: "Por favor completa todos los campos requeridos",
                selectRecipients: "Por favor selecciona al menos un destinatario",
                enterNumbers: "Por favor ingresa al menos un número de teléfono",
                noData: "No hay datos válidos para importar"
              },
              empty: {
                title: "No hay campañas aún",
                description: "¡Crea tu primera campaña!"
              }
            },
            followUp: {
              tooltip: "Seguimiento Inteligente",
              dialog: {
                title: "Seguimiento Inteligente",
                description: "Enviar automáticamente una plantilla de seguimiento si el cliente no responde.",
                status: "Seguimiento Activo",
                selectTemplate: "Seleccionar Plantilla",
                activeTemplate: "Plantilla Activa",
                delay: "Enviar después de",
                minutes: "minutos",
                hour: "hora",
                hours: "horas",
                testMode: "Modo de prueba",
                willSendAfter5min: "Se enviará automáticamente 5 minutos después de tu último mensaje (modo de prueba).",
                willSendAfter1h: "Se enviará automáticamente 1 hora después de tu último mensaje si el cliente no responde.",
                willSendAfter24h: "Se enviará automáticamente 24h después de tu último mensaje si el cliente no responde.",
                close: "Cerrar",
                customerName: "Nombre del Cliente",
                customerNameHint: "Este nombre se usará en la plantilla ({{1}}). Puedes editarlo si es necesario.",
                fillParameters: "Completa las variables de la plantilla:",
                parameter: "Parámetro",
                noParameters: "Esta plantilla no tiene parámetros dinámicos."
              },
              success: {
                enabled: "¡Seguimiento activado!",
                disabled: "Seguimiento desactivado."
              },
              errors: {
                selectTemplate: "Por favor selecciona una plantilla primero."
              }
            },
            announcements: {
              title: "Anuncios",
              searchPlaceholder: "Buscar",
              noRecords: "No hay anuncios",
              priority: {
                high: "Alta",
                medium: "Media",
                low: "Baja"
              },
              status: {
                active: "Activo",
                inactive: "Inactivo"
              },
              buttons: {
                add: "Nuevo Anuncio",
                contactLists: "Listas de Anuncios"
              },
              table: {
                priority: "Prioridad",
                title: "Título",
                text: "Texto",
                mediaName: "Archivo",
                status: "Estado",
                actions: "Acciones"
              },
              dialog: {
                edit: "Edición de Anuncio",
                add: "Nuevo Anuncio",
                update: "Editar Anuncio",
                readonly: "Solo Lectura",
                form: {
                  priority: "Prioridad",
                  title: "Título",
                  text: "Texto",
                  mediaPath: "Archivo",
                  status: "Estado"
                },
                buttons: {
                  add: "Agregar",
                  edit: "Actualizar",
                  okadd: "Ok",
                  cancel: "Cancelar",
                  close: "Cerrar",
                  attach: "Adjuntar Archivo"
                }
              },
              confirmationModal: {
                deleteTitle: "Eliminar",
                deleteMessage: "Esta acción no se puede deshacer."
              },
              toasts: {
                success: "Operación realizada con éxito",
                deleted: "Registro eliminado"
              }
            },
            campaignsConfig: {
              title: "Configuraciones de Campañas"
            },
            queues: {
              title: "Colas y Chatbot",
              table: {
                name: "Nombre",
                color: "Color",
                greeting: "Mensaje de bienvenida",
                actions: "Acciones"
              },
              buttons: {
                add: "Agregar cola"
              },
              confirmationModal: {
                deleteTitle: "Eliminar",
                deleteMessage: "¿Estás seguro? ¡Esta acción no se puede deshacer! Las atenciones de esta cola seguirán existiendo, pero ya no tendrán ninguna cola asignada."
              }
            },
            queueSelect: {
              inputLabel: "Colas"
            },
            queueOptions: {
              forward: "Cambiar de fila"
            },
            users: {
              title: "Usuarios",
              role: {
                admin: "Administrador",
                supervisor: "Supervisor",
                user: "Usuario"
              },
              table: {
                name: "Nombre",
                email: "Correo electrónico",
                profile: "Perfil",
                actions: "Acciones",
                lastLogin: "Último inicio de sesión"
              },
              buttons: {
                add: "Agregar usuario"
              },
              toasts: {
                deleted: "Usuario eliminado con éxito."
              },
              confirmationModal: {
                deleteTitle: "Eliminar",
                deleteMessage: "Todos los datos del usuario se perderán. Las atenciones abiertas de este usuario se moverán a la cola."
              },
              activity: {
                title: "Actividad del usuario",
                filters: {
                  today: "Hoy",
                  last7: "Últimos 7 días",
                  last14: "Últimos 14 días",
                  last21: "Últimos 21 días",
                  last30: "Últimos 30 días",
                  month: "Mes específico"
                },
                kpis: {
                  lastLogin: "Último inicio de sesión",
                  totalLogins: "Total de inicios",
                  totalConnected: "Tiempo total conectado",
                  totalActive: "Tiempo total activo",
                  totalIdle: "Tiempo total inactivo",
                  avgSession: "Duración promedio de sesión",
                  avgDaily: "Actividad diaria promedio"
                },
                sessions: {
                  title: "Detalles de sesiones",
                  date: "Fecha",
                  login: "Entrada",
                  logout: "Salida",
                  duration: "Duración",
                  active: "Activo",
                  idle: "Inactivo",
                  actions: "Acciones",
                  noData: "No hay datos de actividad para el período seleccionado",
                  stillActive: "Activo"
                }
              }
            },
            helps: {
              title: "Centro de Ayuda"
            },
            schedules: {
              title: "Agendamentos",
              confirmationModal: {
                deleteTitle: "¿Está seguro de que desea eliminar esta programación?",
                deleteMessage: "Esta acción no se puede deshacer."
              },
              table: {
                contact: "Contacto",
                body: "Mensaje",
                sendAt: "Fecha de Programación",
                sentAt: "Fecha de Envío",
                status: "Estado",
                actions: "Acciones",
                statusMap: {
                  PENDENTE: "Pendiente",
                  AGENDADA: "Programado",
                  ENVIADA: "Enviado",
                  ERRO: "Error"
                }
              },
              tabs: {
                all: "Todos",
                active: "Activo",
                done: "Completado",
                noResults: "No hay tareas en esta categoría"
              },
              buttons: {
                add: "Nuevo Agendamiento"
              },
              toasts: {
                deleted: "Agendamiento eliminado con éxito."
              }
            },
            tags: {
              title: "Etiquetas",
              confirmationModal: {
                deleteTitle: "¿Está seguro de que quiere eliminar esta etiqueta?",
                deleteMessage: "Esta acción no se puede deshacer."
              },
              table: {
                name: "Nombre",
                color: "Color",
                tickets: "Registros",
                actions: "Acciones",
                id: "ID",
                kanban: "Kanban"
              },
              buttons: {
                add: "Nueva Etiqueta"
              },
              toasts: {
                deleted: "Etiqueta eliminada con éxito."
              }
            },
            whatsappBackups: {
              title: "Copias de seguridad de WhatsApp",
              archive: "Archivo",
              messages: "Mensajes",
              contacts: "Contactos",
              media: "Medios",
              buttons: {
                upload: "Subir copia de seguridad",
                uploading: "Subiendo...",
                download: "Descargar",
                parse: "Analizar",
                preview: "Vista previa del chat",
                restore: "Restaurar",
                restoring: "Restaurando...",
                search: "Buscar",
                searching: "Buscando...",
                validate: "Validar",
                delete: "Eliminar",
                close: "Cerrar",
                cancel: "Cancelar"
              },
              preview: {
                title: "Vista previa del chat",
                loading: "Cargando vista previa...",
                noData: "No hay datos para mostrar",
                dateRange: "Fecha de inicio",
                participants: "Participantes",
                showingMessages: "Mostrando {{shown}} de {{total}} mensajes",
                loadMore: "Cargar 200 más",
                loadAll: "Cargar todos"
              },
              confirmationModal: {
                deleteTitle: "Eliminar copia de seguridad",
                deleteMessage: "¿Estás seguro de que quieres eliminar esta copia de seguridad? Esta acción no se puede deshacer."
              },
              table: {
                fileName: "Nombre del archivo",
                status: "Estado",
                size: "Tamaño",
                format: "Formato",
                messages: "Mensajes",
                contacts: "Contactos",
                phone: "Número de teléfono",
                uploaded: "Subido",
                actions: "Acciones"
              },
              status: {
                uploaded: "Subido",
                processing: "Procesando",
                parsed: "Analizado",
                failed: "Fallido",
                validated: "Validado"
              },
              dragDrop: {
                title: "Arrastra y suelta el archivo aquí",
                dropping: "Suelta el archivo aquí",
                subtitle: "o haz clic para explorar archivos",
                formats: "Formatos soportados: .txt, .json, .html, .zip, .db, .crypt12-15"
              },
              helper: {
                restoreInfo: 'Las conversaciones restauradas aparecen en Tickets → filtro "Closed". Cuando el contacto vuelve a escribir se reabre automáticamente el último ticket para mantener todo el historial unido.'
              },
              search: {
                title: "Buscar en archivo",
                byText: "Buscar por texto",
                bySender: "Buscar por remitente",
                byDate: "Buscar por fecha",
                placeholder: "Buscar por nombre o teléfono",
                results: "Resultados de búsqueda"
              },
              toasts: {
                uploadSuccess: "Copia de seguridad subida exitosamente",
                uploadError: "Error al subir copia de seguridad",
                deleteSuccess: "Copia de seguridad eliminada exitosamente",
                parseSuccess: "Copia de seguridad analizada exitosamente",
                validateSuccess: "Copia de seguridad validada exitosamente",
                restoreSuccess: "Copia de seguridad restaurada exitosamente",
                restoreError: "Error al restaurar copia de seguridad"
              },
              filters: {
                statusLabel: "Estado",
                allStatuses: "Todos los estados",
                phonePlaceholder: "Filtrar por número de teléfono"
              },
              restore: {
                title: "Restaurar copia de seguridad a chats",
                description: "Esto importará todos los mensajes de la copia de seguridad a los tickets activos.",
                selectConnection: "Conexión de WhatsApp",
                customerPhone: "Número de teléfono del cliente",
                customerPhoneHelper: "Ingrese el número de teléfono del cliente de este chat (con código de país, ej. 380936226260)",
                enterPhone: "Por favor ingrese el número de teléfono del cliente",
                file: "Archivo",
                messages: "Mensajes",
                contacts: "Contactos"
              },
              mainTabs: {
                backups: "Copias de Seguridad",
                history: "Historial de Restauración"
              },
              offlineMode: {
                warning: "Estás sin conexión. Mostrando datos en caché."
              },
              history: {
                title: "Historial de Restauración",
                empty: "Sin historial de restauración aún",
                emptyHint: "Las conversaciones restauradas aparecerán aquí",
                fileName: "Archivo de Copia",
                phone: "Teléfono",
                contact: "Contacto",
                messages: "Mensajes",
                restoredAt: "Restaurado En",
                result: "Resultado",
                success: "Éxito",
                failed: "Fallido",
                clearHistory: "Limpiar Historial",
                cleared: "Historial limpiado"
              }
            },
            settings: {
              customDomain: {
                tab: "Dominio propio",
                title: "Dominio propio",
                subtitle: "Sirve tu CRM en tu propia dirección, p. ej. crm.tumarca.com. Añade el dominio, apunta los registros DNS hacia nosotros y emitimos el certificado HTTPS automáticamente.",
                notEntitled: "Los dominios propios están disponibles en un plan superior. Contáctanos para servir tu CRM en tu propia dirección.",
                step1: "1. Introduce tu dominio",
                domainLabel: "Dominio",
                add: "Añadir dominio",
                step2: "2. Añade estos registros DNS en tu proveedor",
                dnsPropagation: "Los cambios de DNS pueden tardar hasta una hora en propagarse. Cuando los registros estén activos, pulsa Comprobar.",
                dnsNotFound: "Registros aún no detectados — revísalos e inténtalo de nuevo.",
                check: "Comprobar DNS",
                remove: "Eliminar",
                activePrefix: "Tu CRM está disponible en",
                open: "Abrir",
                statusActive: "Activo",
                statusDisabled: "Sin configurar",
                statusSsl: "Emitiendo certificado",
                statusDns: "Esperando DNS",
                copy: "Copiar valor",
                copied: "Copiado",
                reserved: "Dominio guardado — añade los registros DNS abajo.",
                removeConfirm: "¿Eliminar este dominio propio?",
                removed: "Dominio propio eliminado.",
              },
              group: {
                general: "General",
                generalDesc: "Configuración principal del bot",
                timeouts: "Tiempos de espera",
                archive: "Archivo",
                officeHours: "Horas de oficina",
                groups: "Grupos",
                groupsDesc: "Configuración de grupos y notificaciones",
                confidenciality: "Confidencialidad",
                api: "API",
                apiDesc: "Integración y acceso",
                serveradmin: "Administración del servidor"
              },
              success: "Configuraciones guardadas exitosamente.",
              title: "Configuraciones",
              updateSuccess: "Actualizado correctamente.",
              pushNotifications: {
                title: "Notificaciones push móviles",
                subtitle: "Gestiona las notificaciones push en la aplicación móvil",
                toggle: {
                  title: "Notificaciones push",
                  helper: "Este ajuste afecta solo a la aplicación móvil."
                },
                scope: {
                  title: "Qué mensajes activan una notificación",
                  all: "Todos los mensajes entrantes",
                  byTag: "Solo conversaciones con etiquetas seleccionadas"
                },
                tags: {
                  title: "Etiquetas seleccionadas",
                  helper: "La notificación se envía solo para conversaciones con una de las etiquetas seleccionadas.",
                  placeholder: "Selecciona etiquetas",
                  empty: "No hay etiquetas disponibles — crea etiquetas primero"
                }
              },
              apiToken: "Token de API",
              apiTokenEmpty: "Aún no se ha generado un token",
              copy: "Copiar",
              generateToken: "Generar token",
              tokenCopied: "Token copiado al portapapeles",
              settings: {
                userCreation: {
                  name: "Creación de usuario",
                  options: {
                    enabled: "Habilitado",
                    disabled: "Deshabilitado"
                  }
                }
              },
              validations: {
                title: "Validaciones",
                options: {
                  enabled: "Habilitado",
                  disabled: "Deshabilitado"
                }
              },
              OfficeManagement: {
                title: "Gestión de despachos",
                options: {
                  disabled: "Deshabilitado",
                  ManagementByDepartment: "Gestión por departamento",
                  ManagementByCompany: "Gestión por empresa"
                }
              },
              outOfHoursAction: {
                title: "Acción fuera del horario",
                options: {
                  pending: "Dejar pendiente",
                  closed: "Cerrar ticket"
                }
              },
              IgnoreGroupMessages: {
                title: "Ignorar mensajes de grupo",
                options: {
                  enabled: "Activado",
                  disabled: "Desactivado"
                }
              },
              soundGroupNotifications: {
                title: "Notificaciones de sonido de grupo",
                options: {
                  enabled: "Activado",
                  disabled: "Desactivado"
                }
              },
              groupsTab: {
                title: "Pestaña de grupos",
                options: {
                  enabled: "Activado",
                  disabled: "Desactivado"
                }
              },
              VoiceAndVideoCalls: {
                title: "Llamadas de voz y vídeo",
                options: {
                  enabled: "Ignorar",
                  disabled: "informe de indisponibilidad"
                }
              },
              AutomaticChatbotOutput: {
                title: "Salida automática del chatbot",
                options: {
                  enabled: "Activado",
                  disabled: "Desactivado"
                }
              },
              chatbotResetDays: {
                title: "Reinicio automático del bot",
                helper: "Días de inactividad antes de reiniciar el bot",
                options: {
                  never: "Nunca",
                  day: "día",
                  days: "días"
                }
              },
              systemLanguage: {
                title: "Idioma del sistema",
                helper: "Por navegador. Cambiar recargará la página.",
                updateSuccess: "Idioma actualizado. Recargando..."
              },
              QuickMessages: {
                title: "Respuestas rápidas",
                options: {
                  enabled: "Por empresa",
                  disabled: "Por Usuario"
                }
              },
              AllowRegistration: {
                title: "Permitir el registro",
                options: {
                  enabled: "Activado",
                  disabled: "Desactivado"
                }
              },
              FileDownloadLimit: {
                title: "Límite de descarga de archivos (MB)"
              },
              removeQueueAndUser: {
                title: "Mantener fila y usuario en ticket cerrado",
                options: {
                  enabled: "Activado",
                  disabled: "Desactivado"
                }
              },
              WelcomeGreeting: {
                greetings: "hola",
                welcome: "bienvenido a",
                expirationTime: "Activo hasta"
              },
              Options: {
                title: "Opciones"
              },
              GPT: {
                title: "GPT AI"
              },
              Templates: {
                title: "Plantillas"
              },
              Archive: {
                title: "Archivo"
              },
              Companies: {
                title: "Empresas"
              },
              schedules: {
                title: "horarios"
              },
              Plans: {
                title: "Planes"
              },
              Help: {
                title: "Ayuda"
              },
              Whitelabel: {
                title: "Whitelabel"
              },
              Subscriptions: {
                title: "Suscripciones"
              }
            },
            contactWhatsappUsername: {
              label: "Nombre de usuario de WhatsApp (@username)",
              placeholder: "john.doe",
              helper: "Opcional — identificador único de WhatsApp (3-35 caracteres, letras minúsculas / dígitos / puntos / guiones bajos)",
              validation: {
                tooShort: "El nombre de usuario debe contener al menos 3 caracteres",
                tooLong: "El nombre de usuario puede contener hasta 35 caracteres",
                invalidChars: "El nombre de usuario solo puede contener letras minúsculas, dígitos, puntos y guiones bajos",
                noWww: "El nombre de usuario no puede comenzar con www.",
                noDomain: "El nombre de usuario no puede terminar con un sufijo de dominio (.com, .net…)"
              }
            },
            time: {
              hourAbbr: "h",
              minuteAbbr: "m",
              dayAbbr: "d"
            },
            messagesList: {
              ack: {
                failed: "No entregado — Meta puede haber bloqueado el mensaje o el número no es válido",
                pending: "Pendiente…",
                sent: "Enviado al servidor de WhatsApp",
                delivered: "Entregado al teléfono del destinatario",
                read: "Leído por el destinatario"
              },
              edited: "Editado",
              quotedImage: "Imagen",
              quotedVideo: "Video",
              quotedAudio: "Mensaje de voz",
              quotedDocument: "Documento",
              quotedSticker: "Sticker",
              replyToYou: "Tú",
              header: {
                assignedTo: "Asignado a:",
                today: "Hoy",
                yesterday: "Ayer",
                selected: "seleccionados",
                buttons: {
                  return: "Regresar",
                  resolve: "Resolver",
                  reopen: "Reabrir",
                  accept: "Aceptar",
                  disableAI: "Desactivar AI",
                  enableAI: "Activar AI",
                  markAsUnread: "Marcar como no leído"
                }
              },
              invalidVCard: "Datos de contacto inválidos",
              messageContact: "Mensaje",
              addToContacts: "Añadir a Contactos",
              contactAdded: "¡Contacto añadido correctamente!",
              contactAddError: "Error al añadir contacto",
              contactExists: "Este contacto ya existe en tu lista de contactos.",
              noPhoneNumber: "Número de teléfono no disponible"
            },
            contactDrawerSections: {
              noLinkedChannels: "No hay canales vinculados",
              openChat: "Abrir chat",
              disconnectChannel: "Desvincular canal",
              channelIdPlaceholder: "ID del canal (teléfono / PSID / email)",
              cancel: "Cancelar",
              connect: "Conectar",
              connectNewChannel: "Conectar canal nuevo",
              statusOpen: "Abierto",
              statusPending: "Pendiente",
              statusClosed: "Cerrado",
              noTicketHistory: "Sin historial de conversaciones",
              totalTickets: "Chats totales",
              openTickets: "Abiertos",
              channels: "Canales",
              customerSince: "Cliente desde",
              communicationChannels: "Canales de comunicación",
              customerJourney: "Recorrido del cliente"
            },
            voiceTimeline: {
              statusCompleted: "Finalizada",
              statusNoAnswer: "Sin respuesta",
              statusBusy: "Ocupado",
              statusFailed: "Fallida",
              statusActive: "En llamada",
              statusRinging: "Sonando",
              statusQueued: "Marcando",
              outcomeSale: "Venta",
              outcomeFollowUp: "Seguimiento",
              outcomeSupport: "Soporte",
              outcomePayment: "Pago",
              outcomeComplaint: "Queja",
              outcomeNoAnswer: "Sin respuesta",
              sentimentPositive: "Positivo",
              sentimentNeutral: "Neutral",
              sentimentNegative: "Negativo",
              sentimentUrgent: "Urgente",
              intentSales: "Venta",
              intentSupport: "Soporte",
              intentPayment: "Pago",
              intentComplaint: "Queja",
              intentInformation: "Información",
              minShort: "min",
              secShort: "s",
              seconds: "segundos",
              outgoing: "Llamada saliente",
              incoming: "Llamada entrante",
              recorded: "Grabada",
              recording: "Grabación",
              listenRecording: "Escuchar grabación",
              aiAnalysis: "Análisis IA",
              transcript: "Transcripción",
              transcribing: "Transcribiendo…",
              createTranscript: "Crear transcripción",
              analyzing: "Analizando…",
              analyzeCall: "Analizar llamada",
              noRecording: "No hay grabación de esta llamada.",
              transcriptNotFound: "No se encontró transcripción (la llamada puede ser muy corta o sin voz).",
              quickCharge: "Cobro rápido",
              followUpAction: "Seguimiento y acción"
            },
            channelFilter: {
              showAll: "Mostrar todo",
              channelLabel: "Canal:",
              label: "Canales",
              all: "Mostrar todos",
              whatsapp: "WhatsApp",
              facebook: "Messenger",
              instagram: "Instagram",
              email: "Correo",
              telegram: "Telegram",
              businessApi: "WhatsApp Business"
            },
            messagesInput: {
              micRequiresHttps: "La grabación de voz requiere una conexión segura (HTTPS) y acceso al micrófono",
              placeholderOpen: "Ingrese un mensaje",
              placeholderClosed: "Reabra o acepte este ticket para enviar un mensaje.",
              signMessage: "Firmar",
              replying: "Respondiendo",
              editing: "Editando"
            },
            messageInput: {
              noTemplates: "No hay plantillas disponibles",
              syncTemplates: "Sincronizar plantillas desde Configuración",
              chooseEmoji: "Elegir emoji",
              emojiPicker: {
                search: "Buscar",
                clear: "Borrar",
                notfound: "No se encontraron emojis",
                categories: {
                  search: "Resultados de búsqueda",
                  recent: "Usados frecuentemente",
                  smileys: "Smileys",
                  people: "Personas",
                  nature: "Naturaleza",
                  foods: "Comida",
                  activity: "Actividades",
                  places: "Lugares",
                  objects: "Objetos",
                  symbols: "Símbolos",
                  flags: "Banderas"
                }
              }
            },
            message: {
              edited: "Editada",
              forwarded: "Reenviado",
              from: "de"
            },
            contactDrawer: {
              header: "Datos de contacto",
              buttons: {
                edit: "Editar contacto"
              },
              extraInfo: "Otra información",
              chatbotNotes: {
                title: "Notas del chatbot"
              },
              travelRequest: {
                title: "Solicitud de viaje",
                score: "puntuación",
                matchedOffers: "Ofertas coincidentes ({{count}})",
                fields: {
                  destination: "🌍 Destino",
                  country: "🗺️ País",
                  productType: "✈️ Tipo",
                  familyComposition: "👨‍👩‍👧 Composición",
                  adults: "🧑 Adultos",
                  children: "👶 Niños",
                  childrenAges: "🎂 Edades",
                  checkInDate: "📅 Entrada",
                  checkOutDate: "📅 Salida",
                  nights: "🌙 Noches",
                  boardBasis: "🍽️ Régimen",
                  budget: "💰 Presupuesto",
                  currency: "💱 Moneda",
                  preferences: "⭐ Preferencias"
                },
                board: {
                  all_inclusive: "Todo incluido",
                  full_board: "Pensión completa",
                  half_board: "Media pensión",
                  bed_breakfast: "Cama y desayuno",
                  room_only: "Solo habitación"
                },
                product: {
                  flight_hotel: "Vuelo + Hotel",
                  flight_only: "Solo vuelo",
                  hotel_only: "Solo hotel"
                }
              }
            },
            contactNotes: {
              toasts: {
                added: "Nota añadida",
                deleted: "Nota eliminada"
              },
              confirm: {
                title: "Eliminar nota",
                message: "¿Estás seguro de que quieres eliminar esta nota?"
              }
            },
            ticketOptionsMenu: {
              schedule: "Agendamiento",
              scheduleAppointment: "📅 Reservar cita",
              appointmentTriggering: "Iniciando bot de citas…",
              appointmentTriggered: "Bot de citas iniciado — saludo enviado.",
              delete: "Eliminar",
              transfer: "Transferir",
              resetChatbot: "🔄 Reiniciar Bot",
              requestPayment: "💳 Solicitar pago",
              mergeBackup: "Importar historial",
              downloadConversation: "📥 Descargar conversación",
              downloading: "Descargando...",
              registerAppointment: "Observaciones del Contacto",
              appointmentsModal: {
                title: "Observaciones del Contacto",
                textarea: "Observación",
                placeholder: "Ingrese aquí la información que desea registrar"
              },
              confirmationModal: {
                title: "Eliminar el ticket del contacto",
                message: "¡Atención! Todas las mensajes relacionados con el ticket se perderán."
              },
              buttons: {
                delete: "Eliminar",
                cancel: "Cancelar"
              }
            },
            confirmationModal: {
              buttons: {
                confirm: "Ok",
                cancel: "Cancelar"
              }
            },
            messageOptionsMenu: {
              delete: "Eliminar",
              edit: "Editar",
              history: "Historial",
              reply: "Responder",
              copy: "Copiar",
              copied: "Texto copiado",
              forward: "Reenviar",
              forwardbutton: "Seleccionar usuario para reenviar",
              reactions: "Reacciones",
              removeReactions: "Eliminar reacción",
              confirmationModal: {
                title: "¿Borrar mensaje?",
                message: "Esta acción no se puede deshacer."
              }
            },
            messageHistoryModal: {
              close: "Cerrar",
              title: "Historial de edición del mensaje"
            },
            presence: {
              unavailable: "Indisponible",
              available: "Disponible",
              composing: "Componiendo",
              recording: "Grabando",
              paused: "Pausado"
            },
            privacyModal: {
              title: "Editar privacidad de Whatsapp",
              buttons: {
                cancel: "Cancelar",
                okEdit: "Ahorrar"
              },
              form: {
                menu: {
                  all: "Todo",
                  none: "Nadie",
                  contacts: "Mis contactos",
                  contact_blacklist: "Contactos seleccionados",
                  match_last_seen: "Partido visto por última vez",
                  known: "Conocido",
                  disable: "Desactivado",
                  hrs24: "24 Horas",
                  dias7: "7 Días",
                  dias90: "90 Días"
                },
                readreceipts: "Para actualizar la privacidad de Confirmaciones de lectura",
                profile: "Para actualizar la privacidad de la foto de perfil",
                status: "Para actualizar la privacidad del mensajes",
                online: "Para actualizar la privacidad en línea",
                last: "Para actualizar la privacidad de Última visita",
                groupadd: "Para actualizar la privacidad de Agregar grupos",
                calladd: "Para actualizar la privacidad de Agregar llamada",
                disappearing: "Para actualizar el modo de desaparición predeterminado"
              }
            },
            contactProfile: {
              title: "Inteligencia del Cliente",
              emptyState: "El perfil se construirá automáticamente desde la conversación",
              confidence: "Confianza",
              updated: "Actualizado",
              profileNotBuilt: "El perfil aún no está creado",
              sections: {
                personal: "Personal",
                travel: "Intereses de Viaje",
                family: "Familia",
                preferences: "Preferencias"
              },
              labels: {
                name: "Nombre",
                language: "Idioma",
                country: "País",
                destinations: "Destinos",
                months: "Meses",
                duration: "Duración",
                budget: "Presupuesto",
                accommodation: "Alojamiento",
                adults: "Adultos",
                children: "Niños",
                ages: "Edades",
                requirements: "Requisitos",
                interest: "Interés",
                style: "Estilo",
                activities: "Actividades"
              },
              fields: {
                customerName: "Nombre del cliente",
                destination: "Destino",
                travelDates: "Fechas/meses de viaje",
                adultsCount: "Número de adultos",
                childrenAges: "Edades de los niños"
              },
              readyToBook: {
                title: "Listo para Reservar",
                statusReady: "Listo",
                statusAlmost: "Casi",
                statusMissing: "Falta Info",
                noProfile: "Sin Perfil",
                noProfileDesc: "Se necesita perfil del cliente antes de generar resumen de reserva. El perfil se construye automáticamente cuando la IA extrae información de la conversación.",
                missingInfo: "Información faltante",
                generating: "Generando...",
                generateSummary: "Generar Resumen de Reserva",
                tryGenerate: "Intentar Generar",
                copyToClipboard: "Copiar al portapapeles",
                statusReadyFull: "Listo para Reservar",
                statusAlmostFull: "Casi Listo",
                statusMoreInfo: "Se Necesita Más Info"
              },
              toasts: {
                ticketRequired: "Se requiere ID del ticket para generar resumen",
                generateFailed: "Error al generar resumen de reserva",
                copied: "Resumen copiado al portapapeles"
              }
            },
            backendErrors: {
              ERR_VOICE_DIAL_FAILED: "No se pudo realizar la llamada. Verifica que las llamadas al país de destino estén habilitadas en la cuenta.",
              ERR_META_MEDIA_UNSUPPORTED: "El envío de archivos aún no es compatible con este canal.",
              ERR_MEDIA_TOO_LARGE: "Este archivo es demasiado grande para enviarse en este canal (máx. 20 MB).",
              ERR_META_SEND_FAILED: "No se pudo enviar el mensaje en este canal — inténtalo de nuevo.",
              ERR_META_TOKEN_INVALID: "La conexión del canal caducó — vuelve a conectarla en ajustes.",
              ERR_FACEBOOK_WINDOW_EXPIRED: "La ventana de respuesta de 24 horas se cerró; el cliente debe escribir primero.",
              ERR_META_COMMENT_REPLY_NOT_PERMITTED: "Facebook no permite una respuesta privada a un comentario de publicación (se requiere revisión de la app). Para responder, el cliente debe escribirte por Messenger.",
              ERR_EDIT_NOT_SUPPORTED_FOR_CHANNEL: "La edición de mensajes no es compatible con este canal.",
              ERR_DELETE_NOT_SUPPORTED_FOR_CHANNEL: "La eliminación de mensajes no es compatible con este canal.",
              ERR_CANNOT_FORWARD_TO_OMNICHANNEL: "El reenvío a este canal no es compatible.",
              ERR_CANNOT_FORWARD_FROM_OMNICHANNEL: "El reenvío desde este canal no es compatible.",
              ERR_MESSAGE_BODY_REQUIRED: "Se requiere el texto del mensaje.",
              ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
              ERR_NO_DEF_WAPP_FOUND: "No se encontró ningún WhatsApp predeterminado. Verifique la página de conexiones.",
              ERR_WAPP_NOT_INITIALIZED: "Esta sesión de WhatsApp no se ha inicializado. Verifique la página de conexiones.",
              ERR_WAPP_CHECK_CONTACT: "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones",
              ERR_WAPP_INVALID_CONTACT: "Este no es un número de WhatsApp válido.",
              ERR_WAPP_DOWNLOAD_MEDIA: "No se pudo descargar medios de WhatsApp. Verifique la página de conexiones.",
              ERR_INVALID_CREDENTIALS: "Error de autenticación. Por favor, inténtelo de nuevo.",
              ERR_SENDING_WAPP_MSG: "Error al enviar mensaje de WhatsApp. Verifique la página de conexiones.",
              ERR_DELETE_WAPP_MSG: "No se pudo eliminar el mensaje de WhatsApp.",
              ERR_EDITING_WAPP_MSG: "No se pudo editar el mensaje de WhatsApp.",
              ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
              ERR_SESSION_EXPIRED: "Sesión expirada. Por favor, inicie sesión.",
              ERR_USER_CREATION_DISABLED: "La creación de usuarios está deshabilitada por el administrador.",
              ERR_NO_PERMISSION: "No tiene permisos para acceder a este recurso.",
              ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
              ERR_NO_SETTING_FOUND: "No se encontró ninguna configuración con este ID.",
              ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
              ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
              ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
              ERR_NO_WAPP_FOUND: "No se encontró ningún WhatsApp con este ID.",
              ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
              ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
              ERR_FETCH_WAPP_MSG: "Error al recuperar el mensaje de WhatsApp, tal vez sea muy antiguo.",
              ERR_QUEUE_COLOR_ALREADY_EXISTS: "Este color ya está en uso, elija otro.",
              ERR_WAPP_GREETING_REQUIRED: "El mensaje de saludo es obligatorio cuando hay más de una cola."
            },
            godeal: {
              support: {
                title: "Apoyar el proyecto godeal",
                mercadopagotitle: "Tarjeta de crédito",
                recurringbrl: "Donaciones recurrentes en BRL",
                paypaltitle: "Tarjeta de crédito",
                international: "Donaciones en USD"
              }
            },
            scheduleMessageModal: {
              title: "Programar Mensaje",
              messagePreview: "Mensaje a enviar:",
              noMessage: "No se ingresó mensaje",
              quickSelect: "Selección rápida:",
              minutes: "min",
              hour: "hora",
              hours: "horas",
              tomorrow: "Mañana",
              dateTime: "Fecha y Hora",
              sendTo: "Se enviará a:",
              cancel: "Cancelar",
              schedule: "Programar",
              scheduling: "Programando...",
              success: "¡Mensaje programado exitosamente!",
              errors: {
                noMessage: "Por favor ingrese un mensaje primero",
                noDate: "Por favor seleccione fecha y hora",
                pastDate: "Por favor seleccione una fecha futura"
              }
            },
            mergeBackupModal: {
              title: "Importar Historial de Chat",
              selectBackup: "Por favor seleccione una copia de seguridad para importar",
              selectBackupHint: "Seleccione un archivo de respaldo que coincida con el número de teléfono de este contacto:",
              noBackups: "No se encontraron copias de seguridad coincidentes",
              noBackupsHint: "Cargue copias de seguridad con números de teléfono en el nombre del archivo para habilitar la importación",
              phone: "Teléfono",
              merge: "Importar Historial",
              merging: "Importando...",
              close: "Cerrar",
              success: "¡Historial de chat importado exitosamente!",
              mergeComplete: "Importación Completa",
              messagesCreated: "Mensajes importados",
              messagesSkipped: "Duplicados omitidos"
            },
            teams: {
              title: "Gestión de Equipos",
              stats: {
                totalTeams: "Total de Equipos",
                totalMembers: "Total de Miembros"
              },
              empty: {
                title: "Aún no hay equipos",
                description: "Crea tu primer equipo para organizar tus agentes"
              },
              table: {
                name: "Nombre del Equipo",
                description: "Descripción",
                members: "Miembros",
                actions: "Acciones"
              },
              buttons: {
                new: "Nuevo Equipo",
                createFirst: "Crear Primer Equipo",
                cancel: "Cancelar",
                create: "Crear",
                save: "Guardar"
              },
              membersCount: "miembros",
              noMembers: "Sin miembros",
              dialog: {
                newTitle: "Nuevo Equipo",
                editTitle: "Editar Equipo"
              },
              form: {
                name: "Nombre del Equipo",
                description: "Descripción",
                members: "Miembros del Equipo",
                searchUsers: "Buscar usuarios...",
                noUsersFound: "No se encontraron usuarios",
                tryDifferentSearch: "Intenta con otra búsqueda"
              },
              actions: {
                edit: "Editar",
                delete: "Eliminar"
              },
              deleteConfirm: {
                title: "Eliminar Equipo",
                message: "¿Estás seguro de que deseas eliminar este equipo?"
              },
              messages: {
                created: "Equipo creado exitosamente",
                updated: "Equipo actualizado exitosamente",
                deleted: "Equipo eliminado exitosamente"
              },
              errors: {
                loadFailed: "Error al cargar equipos",
                saveFailed: "Error al guardar equipo",
                deleteFailed: "Error al eliminar equipo",
                nameRequired: "El nombre del equipo es obligatorio"
              }
            },
            aiWizard: {
              title: "Configuración de IA",
              subtitle: "Configura tu asistente de IA en unos simples pasos",
              steps: {
                companyInfo: "Info de empresa",
                aiAgent: "Agente IA",
                dataSources: "Fuentes de datos",
                externalCrm: "CRM Externo",
                handoffRules: "Reglas de transferencia",
                greeting: "Saludo"
              },
              next: "Siguiente",
              back: "Atrás",
              finishSave: "Finalizar y guardar",
              savedSuccess: "¡Configuración de IA guardada con éxito!",
              saveFailed: "Error al guardar la configuración",
              companyStep: {
                companyName: "Nombre de la empresa",
                companyNamePlaceholder: "ej. Mi agencia de viajes",
                timezone: "Zona horaria",
                responseLanguage: "Idioma de respuesta",
                timezones: {
                  israel: "Israel (Asia/Jerusalem)",
                  uk: "Reino Unido (Europe/London)",
                  usEast: "EE.UU. Este (America/New_York)",
                  ukraine: "Ucrania (Europe/Kiev)"
                },
                languages: {
                  hebrew: "Hebreo (עברית)",
                  english: "Inglés",
                  russian: "Ruso (Русский)",
                  arabic: "Árabe (العربية)"
                }
              },
              aiStep: {
                describeCompany: "Describe tu empresa y el comportamiento de la IA",
                describePlaceholder: "ej. Somos una agencia de viajes especializada en vacaciones familiares. La IA debe ser útil, sugerir destinos y recopilar preferencias...",
                tone: "Tono de comunicación",
                model: "Modelo de IA",
                tones: {
                  professional: "Profesional",
                  friendly: "Amigable",
                  formal: "Formal"
                },
                models: {
                  gpt4o: "GPT-4o (Mejor calidad)",
                  gpt4oMini: "GPT-4o Mini (Más rápido y económico)"
                }
              },
              dataStep: {
                description: "Conecta APIs externas para que la IA pueda obtener datos reales (productos, inventario, precios) durante las conversaciones. Esto es opcional.",
                summaryTemplate: "Plantilla de resumen",
                summaryPlaceholder: "Cómo mostrar datos recopilados antes de los resultados. Usa {{fields}} como marcador.",
                dataSourceNum: "Fuente de datos #{{num}}",
                name: "Nombre",
                namePlaceholder: "ej. Catálogo de productos",
                apiUrl: "URL de API",
                apiUrlPlaceholder: "https://api.miempresa.com/productos",
                description2: "Descripción (para IA)",
                descriptionPlaceholder: "Buscar productos por criterios del cliente",
                requiredFields: "Campos requeridos (separados por comas)",
                requiredFieldsPlaceholder: "ej. categoría, presupuesto, tamaño, estilo",
                requiredFieldsHelper: "La IA recopilará estos campos uno por uno antes de buscar",
                addDataSource: "Agregar fuente de datos"
              },
              crmStep: {
                description: "Conecta un CRM externo (Supabase) para autocompletar datos de clientes desde tu base de datos. Puedes omitir este paso.",
                enable: "Habilitar CRM externo",
                supabaseUrl: "URL de Supabase",
                supabaseKey: "Clave API de Supabase",
                testConnection: "Probar Conexión",
                tableName: "Tabla de búsqueda",
                phoneField: "Columna de teléfono",
                nameFields: "Columnas de nombre",
                nameFieldsHelp: "Separados por comas, ej. first_name, last_name",
                detectedFields: "Columnas detectadas",
                skipNote: "Este paso es opcional. Si no tienes un CRM externo, simplemente haz clic en Siguiente."
              },
              handoffStep: {
                description: "Define cuándo la IA debe transferir la conversación a un agente humano.",
                customPlaceholder: "Describe la condición de transferencia personalizada...",
                addCustomRule: "Agregar regla personalizada",
                triggers: {
                  pricing: "El cliente pregunta sobre precios",
                  complaint: "Queja del cliente",
                  humanRequest: "El cliente pide un agente humano",
                  aiFailure: "La IA no puede responder"
                }
              },
              greetingStep: {
                enableGreeting: "Habilitar saludo automático",
                greetingMessage: "Mensaje de saludo",
                greetingPlaceholder: "ej. ¡Hola! Bienvenido a nuestra tienda. ¿En qué puedo ayudarte hoy?"
              }
            },
            tour: {
              buttons: {
                back: "Atrás",
                close: "Cerrar",
                last: "Finalizar",
                next: "Siguiente",
                skip: "Omitir tour"
              },
              welcome: {
                title: "¡Bienvenido a Whapiz! 👋",
                content: "Configuremos tu negocio en 4 pasos simples. Toma unos 5 minutos."
              },
              connections: {
                title: "Paso 1 — Conecta tu número de WhatsApp",
                content: "Haz clic aquí para abrir la página de Conexiones, donde agregarás tu número de WhatsApp Business API.",
                contentMobile: "Toca el menú ☰ arriba a la izquierda, luego elige 'Conexiones'. Ahí es donde conectas tu número de WhatsApp Business API."
              },
              metaButton: {
                title: "Haz clic en 'Conectar WhatsApp Business API'",
                content: "Tu equipo te proporcionará 3 valores de Meta Business Manager: Phone Number ID, WABA ID y un API Token. Pégalos en el paso 2 del asistente y listo."
              },
              queues: {
                title: "Paso 2 — Crea tu primera cola",
                content: "Las colas organizan los chats entrantes por departamento o tema (Ventas, Soporte, Facturación…). Haz clic aquí, luego '+Agregar' para crear la primera.",
                contentMobile: "Toca el menú ☰, luego 'Colas'. Las colas organizan los chats entrantes por departamento (Ventas, Soporte, Facturación…). Toca '+Agregar' para crear la primera."
              },
              botChoice: {
                title: "Paso 3 — Elige cómo responde tu bot",
                content: "Tienes dos opciones:\n\n📋 BOT DE MENÚ SIMPLE — Los clientes ven un menú numerado (1 - Ventas, 2 - Soporte…). Fácil de configurar dentro de cada Cola → pestaña Opciones.\n\n🤖 ASISTENTE AI — GPT-4 responde en lenguaje natural. Mejor para ventas y preguntas complejas. El siguiente paso abre el asistente de configuración de AI.\n\nPuedes omitir esto por ahora y decidir luego."
              },
              aiSettings: {
                title: "Asistente AI (opcional)",
                content: "Completa los 6 pasos cortos para enseñar al AI sobre tu negocio: información de la empresa, tono de voz, fuentes de conocimiento, integración CRM, cuándo transferir a un humano, y el saludo. El AI usa GPT-4 y responde en el idioma de tu cliente. Omite este paso si prefieres un bot de menú simple."
              },
              users: {
                title: "Paso 4 — Invita a tu equipo",
                content: "Agrega los agentes que manejarán los chats con clientes. Cada agente obtiene su propio inicio de sesión y bandeja.",
                contentMobile: "Toca el menú ☰, luego 'Usuarios'. Agrega los agentes que manejarán los chats con clientes — cada agente obtiene su propio inicio de sesión."
              },
              done: {
                title: "🎉 ¡Todo listo!",
                content: "Tus clientes ya pueden enviarte mensajes y tu equipo puede responder desde aquí. Puedes reiniciar este tour en cualquier momento desde el menú de perfil."
              }
            },
            setupAssistant: {
              title: "Asistente de Configuración AI",
              subtitle: "Describe tu negocio — configuraré el bot",
              welcomeTitle: "¿Cómo puedo ayudarte a configurar?",
              welcomeText: "Describe tu negocio o elige un inicio rápido:",
              welcomeQuestions: "¡Hola! Te ayudaré a configurar tu bot de WhatsApp. Comencemos con algunas preguntas:\n\n1. **Modo bot** — ¿qué prefieres?\n• **Chatbot** — menú con categorías, preguntas estructuradas\n• **AI Directo** — conversación libre, sin menús\n\n2. **Categorías** — ¿sobre qué temas te contactan tus clientes? (ej: reparaciones, pagos, citas...)\n\n3. **CRM** — ¿tienes una base de datos de clientes que quieras conectar?\n\n¡Responde y construiremos tu bot paso a paso!",
              inputPlaceholder: "Describe tu negocio...",
              error: "Lo siento, algo salió mal. Intenta de nuevo.",
              applied: "¡Configuración aplicada! Revisa los campos y haz clic en Guardar.",
              configReady: "Configuración Lista",
              applyConfig: "Aplicar Configuración",
              restart: "Empezar de nuevo",
              suggestions: {
                building: "Empresa de gestión de edificios",
                clinic: "Clínica médica",
                restaurant: "Restaurante / delivery",
                cleaning: "Servicios de limpieza",
                law: "Bufete de abogados"
              },
              config: {
                company: "Empresa",
                mode: "Modo del Bot",
                language: "Idioma",
                tone: "Tono",
                queues: "Colas",
                greeting: "Saludo",
                tasks: "Tareas automáticas",
                crm: "Integración CRM"
              }
            },
            subscriptionsManager: {
              title: "Suscripciones de Empresas",
              subtitle: "Asignaciones de plan y facturación de todos los clientes",
              loadFailed: "Error al cargar suscripciones",
              assignPlan: "Asignar Plan",
              assignSuccess: "Plan asignado exitosamente",
              assignFailed: "Error al asignar plan",
              cancelConfirm: "¿Estás seguro de que deseas cancelar esta suscripción?",
              cancelSuccess: "Suscripción cancelada",
              cancelFailed: "Error al cancelar suscripción",
              recordPayment: "Registrar Pago",
              paymentSuccess: "Pago registrado exitosamente",
              paymentFailed: "Error al registrar pago",
              refresh: "Actualizar",
              cancel: "Cancelar",
              noSubscriptions: "Sin suscripciones aún. Asigna planes a empresas para comenzar.",
              emptyDescription: "Aún no hay suscripciones. Los inquilinos aparecerán aquí cuando activen un plan.",
              table: {
                company: "Empresa",
                plan: "Plan",
                status: "Estado",
                period: "Período de Facturación",
                 autoRenew: "Renovación automática",
                actions: "Acciones"
              },
              form: {
                companyId: "ID de Empresa",
                plan: "Plan",
                status: "Estado",
                periodMonths: "Período (meses)",
                amount: "Monto",
                currency: "Moneda",
                description: "Descripción",
                type: "Tipo de Pago",
                cancel: "Cancelar",
                assign: "Asignar",
                record: "Registrar Pago"
              }
            },
            billingPage: {
    paymentVerifying: "Verificando tu pago…",
    paymentVerifyingDesc: "Espera mientras confirmamos la transacción con el proveedor de pagos.",
    paymentSuccessNoRef: "Falta la referencia de pago",
    paymentSuccessNoRefDesc: "No encontramos una referencia de transacción para verificar. Revisa tu página de facturación.",
    paymentPendingTitle: "El pago aún se está procesando",
    paymentPendingSubtitle: "Todavía no recibimos una confirmación final. Esto puede tardar un momento.",
    paymentCheckAgain: "Comprobar de nuevo",
    paymentNotFoundTitle: "Transacción no encontrada",
    paymentNotFoundSubtitle: "No pudimos encontrar esta transacción. Si te cobraron, contacta con soporte.",
    paymentFailedTitle: "El pago no se completó",
    paymentFailedSubtitle: "La transacción no se completó. No se te ha cobrado.",
    paymentSupportLine: "¿Necesitas ayuda? Escríbenos a {{email}}.",
    backToBilling: "Volver a facturación",
    backToDashboard: "Volver al panel",
    viewInvoices: "Ver facturas",
    psPlan: "Plan",
    psBillingPeriod: "Período de facturación",
    psReference: "Referencia",
    psDate: "Fecha",
    psCard: "Tarjeta",
    psStarts: "Inicio de la suscripción",
    psNextCharge: "Próximo cobro",
    psAutoRenew: "Renovación automática",
    psAutoRenewOff: "Renovación automática desactivada",
    psAmount: "Importe cobrado",
    psInvoiceSent: "Se envió una factura a {{email}}.",
    psInvoiceNote: "Tu factura está disponible en la página de facturación.",
    interval_monthly: "Mensual",
    interval_yearly: "Anual",
    on: "Activada",
    off: "Desactivada",

              title: "Facturación y Suscripción",
              subtitle: "Gestiona tu plan de suscripción, historial de pagos y facturas",
              loadFailed: "Error al cargar datos de facturación",
              tabs: {
                overview: "Resumen del Plan",
                payments: "Historial de Pagos",
                invoices: "Facturas y Recibos"
              },
              currentPlan: "Plan Actual",
              noPlan: "Sin Plan Asignado",
              noPlanDesc: "Contacta al administrador para asignar un plan de suscripción.",
              noSubscription: "Sin suscripción activa. Tu plan está asignado pero la facturación aún no ha comenzado.",
              perMonth: "mes",
              perYear: "año",
              trialBilling: "Período de prueba",
              periodStart: "Inicio del Período",
              periodEnd: "Fin del Período",
              trialEnds: "Prueba Termina",
              features: {
                users: "Usuarios",
                connections: "Conexiones WhatsApp",
                queues: "Colas",
                ai: "Agente AI Incluido",
                crm: "Integración CRM"
              },
              paymentHistory: "Historial de Pagos",
              noPayments: "Sin pagos aún. Tu historial de pagos aparecerá aquí.",
              invoiceHistory: "Facturas y Recibos",
              noInvoices: "Sin facturas aún. Tus facturas aparecerán aquí después de los pagos.",
              downloadInvoice: "Descargar Factura",
              payNow: "Pagar ahora",
              renewSubscription: "Renovar suscripción",
              renewDesc: "Continúa con tu plan y mantén el acceso sin interrupciones.",
              renewLoading: "Procesando…",
              renewFailed: "Falló la renovación. Inténtalo de nuevo.",
              paymentSuccess: "Pago realizado con éxito",
              paymentFailed: "El pago falló",
              pastDueBanner: "Tu suscripción está vencida. Paga para restaurar el acceso.",
              trialBanner: "Tu prueba está activa. Mejora en cualquier momento para mantener el acceso.",
              noTerminal: "No hay terminal de pago configurada. Contacta a soporte.",
              table: {
                date: "Fecha",
                description: "Descripción",
                amount: "Monto",
                status: "Estado",
                method: "Método",
                invoice: "Factura #",
                actions: "Acciones"
              }
            },
            requestPaymentDialog: {
              title: "Solicitar pago",
              confirmTitle: "Confirmar solicitud de pago",
              recipient: "Destinatario",
              unnamedContact: "este contacto",
              amountLabel: "Importe",
              currencyLabel: "Moneda",
              descriptionLabel: "Descripción",
              descriptionHelp: "Se muestra al cliente en la página de Tranzila. Máx. 80 caracteres.",
              confirmBody: "Enviar enlace de pago por",
              confirmTo: "a",
              confirmHelp: "El enlace se entregará como un mensaje de WhatsApp en esta conversación.",
              invalidAmount: "Ingresa un importe de al menos 0.01.",
              invalidDescription: "Ingresa una descripción corta (máx. 80 caracteres).",
              sentSuccess: "Enlace de pago enviado al cliente.",
              sendFailed: "Error al enviar el enlace de pago. Inténtalo de nuevo.",
              noTerminal: "No hay terminal de Tranzila configurada para tu empresa.",
              openSettings: "Abrir Ajustes → Pagos",
              cancel: "Cancelar",
              next: "Siguiente",
              sendNow: "Enviar enlace de pago"
            },
            aiWorkforcePage: {
              title: "AI Workforce",
              subtitle: "Reglas, registros de acciones y interruptor maestro para el pipeline del AI Agent.",
              notForTenant: {
                title: "No disponible para este inquilino",
                help: "La consola AI Workforce solo es utilizada por el pipeline heredado de GoDeal. Los inquilinos genéricos configuran la IA desde la página Configuración de IA."
              },
              toggle: {
                title: "AI Workforce",
                description: "Interruptor maestro — cuando está apagado, el pipeline del AI Agent se omite por completo.",
                enabled: "AI Workforce habilitado",
                disabled: "AI Workforce deshabilitado",
                failed: "Error al cambiar AI Workforce"
              },
              tabs: {
                stats: "Estadísticas",
                rules: "Reglas",
                logs: "Registros de acciones"
              },
              stats: {
                totalAgents: "Agentes",
                activeAgents: "Activos",
                totalRules: "Reglas",
                totalKnowledge: "Conocimiento",
                actionsToday: "Acciones hoy"
              },
              rules: {
                empty: "Aún no se han definido reglas.",
                newRule: "Nueva regla",
                editRule: "Editar regla",
                edit: "Editar regla",
                delete: "Eliminar regla",
                deleted: "Regla eliminada",
                created: "Regla creada",
                updated: "Regla actualizada",
                deleteFailed: "Error al eliminar la regla",
                updateFailed: "Error al actualizar la regla",
                confirmDelete: "¿Eliminar la regla \"{{name}}\"? Esta acción no se puede deshacer.",
                col: {
                  name: "Nombre",
                  type: "Tipo",
                  priority: "Prioridad",
                  active: "Activa",
                  actions: "Acciones"
                },
                form: {
                  name: "Nombre",
                  type: "Tipo",
                  typeHelp: "Etiqueta libre, p. ej. \"handoff\", \"intake_completed\", \"escalation\"",
                  priority: "Prioridad",
                  active: "Activa",
                  description: "Descripción (opcional)",
                  conditions: "Condiciones (JSON)",
                  actions: "Acciones (JSON)",
                  jsonHelp: "El esquema depende del motor. Consulta la documentación de AIAgentEngine.",
                  save: "Guardar",
                  cancel: "Cancelar",
                  saveFailed: "Error al guardar la regla",
                  invalidJson: "JSON no válido",
                  nameTypeRequired: "Nombre y tipo son obligatorios"
                }
              },
              logs: {
                empty: "Aún no hay registros de acciones.",
                col: {
                  when: "Cuándo",
                  action: "Acción",
                  agent: "Agente",
                  ticket: "Ticket",
                  status: "Estado",
                  latency: "Latencia",
                  error: "Error"
                }
              },
              refresh: "Actualizar",
              agents: {
                calendarConnected: "Calendario conectado ✓",
                secretaryName: "Secretaria IA — Programación de citas",
                secretarySubtitle: "Conectado al calendario — reuniones en conversación natural",
                roles: {
                  appointment_scheduler: "Programador de citas"
                }
              }
            },
            aiSettingsPage: {
              title: "Configuración de IA",
              subtitle: "Configura el comportamiento de tu asistente de IA",
              goToAIWorkforce: "Ir a AI Workforce",
              aiWorkforce: {
                title: "AI Workforce",
                description: "Habilitar o deshabilitar todo el procesamiento de IA para esta empresa",
                enabled: "AI Workforce habilitado",
                disabled: "AI Workforce deshabilitado",
                toggleFailed: "Error al cambiar AI Workforce"
              },
              saveChanges: "Guardar cambios",
              saving: "Guardando...",
              settingsSaved: "¡Configuración guardada!",
              failedToLoad: "Error al cargar configuración de IA",
              failedToSave: "Error al guardar configuración",
              companyInfo: {
                title: "Información de la empresa",
                companyName: "Nombre de la empresa",
                companyNameHelp: "El nombre visible de tu empresa. Aparece en mensajes y saludos dirigidos a clientes.",
                timezone: "Zona horaria",
                timezoneHelp: "Configura tu zona horaria local. Afecta mensajes programados, seguimientos y horarios de trabajo.",
                language: "Idioma",
                languageHelp: "El idioma principal que el bot de AI usará para comunicarse con los clientes.",
                timezones: {
                  israel: "Israel",
                  uk: "Reino Unido",
                  usEast: "EE.UU. Este",
                  ukraine: "Ucrania"
                },
                languages: {
                  hebrew: "Hebreo",
                  english: "Inglés",
                  russian: "Ruso",
                  arabic: "Árabe"
                }
              },
              aiBehavior: {
                title: "Comportamiento de IA",
                titleHelp: "Controla cómo responde el AI a los clientes — su personalidad, base de conocimiento y capacidades.",
                systemPrompt: "Prompt del sistema",
                systemPromptHelp: "Instrucciones personalizadas para el AI. Describe qué debe saber, cómo comportarse y qué nunca debe hacer. Esta es la configuración más importante para controlar el comportamiento del AI.",
                tone: "Tono",
                toneHelp: "El estilo conversacional del AI. Profesional = empresarial, Amigable = cálido e informal, Formal = estricto y cortés.",
                model: "Modelo",
                modelHelp: "El modelo de AI a usar. GPT-5 es el más capaz pero más lento/costoso. GPT-4o Mini es rápido y económico para tareas simples.",
                aiEnabled: "Agente IA habilitado",
                tones: {
                  professional: "Profesional",
                  friendly: "Amigable",
                  formal: "Formal"
                }
              },
              dataSources: {
                title: "Fuentes de datos",
                description: "APIs externas que la IA puede usar para obtener datos en tiempo real.",
                sourceType: "Tipo de fuente de datos",
                sourceTypeHelp: "Cómo accede el AI a tu catálogo de productos/servicios. REST API = endpoint personalizado. Supabase = consulta directa a BD. Ninguno = sin búsqueda en catálogo.",
                none: "Ninguno",
                restApi: "REST API",
                supabase: "Supabase",
                supabaseUrl: "URL de Supabase",
                supabaseApiKey: "Clave API de Supabase",
                summaryTemplate: "Plantilla de resumen",
                summaryHelperText: "Cómo mostrar datos recopilados. Usa {{fields}} como marcador.",
                toolName: "Nombre",
                toolNameHelp: "Un nombre descriptivo para esta fuente de datos. Ejemplo: 'Búsqueda de Paquetes Vacacionales', 'Catálogo de Productos'.",
                toolApiUrl: "URL de API",
                toolApiUrlHelp: "La URL completa del endpoint de la API. El AI llamará a esta URL para buscar productos/servicios.",
                toolDescription: "Descripción",
                toolDescriptionHelp: "Explica qué hace esta API en lenguaje simple. El AI usa esto para decidir cuándo llamarla.",
                requiredFields: "Campos requeridos (separados por comas)",
                requiredFieldsHelp: "Campos que el AI debe recopilar del cliente antes de llamar a esta API. Deja vacío para navegación simple del catálogo.",
                requiredFieldsPlaceholder: "ej. categoría, presupuesto (opcional)",
                requiredFieldsHelper: "Para consultas simples — dejar vacío. Solo para búsqueda filtrada.",
                addDataSource: "Agregar fuente de datos",
                maxProductCardsHelp: "Cuántas tarjetas de producto/servicio mostrar por búsqueda. Menos = respuesta más rápida, más = más opciones para el cliente.",
                filterConfigHelp: "Configuración JSON avanzada que mapea datos del cliente a parámetros de consulta API. Solo edita si conoces la estructura de tu API."
              },
              categoryStructure: {
                title: "Estructura de categorías",
                titleHelp: "Las categorías ayudan al AI a organizar productos/servicios. Cuando un cliente busca algo, el AI filtra por estas categorías. Puedes auto-detectar desde tus datos o agregar manualmente.",
                description: "La IA usa esta estructura para entender las categorías y filtrar elementos con precisión. Escanea tu fuente de datos para detectar automáticamente o configura manualmente.",
                autoDetect: "Detección automática",
                scanning: "Escaneando...",
                autoDetected: "Auto-detectado",
                manual: "Manual",
                lastScan: "Último escaneo",
                categoryField: "Campo de categoría",
                categoryFieldHelper: "El campo en tus datos que contiene la categoría",
                subcategoryField: "Campo de subcategoría",
                subcategoryFieldHelper: "Campo de agrupación secundaria opcional",
                items: "elementos",
                noCategories: "No se detectaron categorías. Haz clic en \"Detección automática\" para escanear.",
                addManually: "Agregar categoría manualmente",
                editName: "Editar nombre",
                remove: "Eliminar",
                detected: "Se detectaron {{count}} categorías",
                detectionFailed: "Detección fallida",
                failedToScan: "Error al escanear categorías"
              },
              handoffRules: {
                title: "Reglas de transferencia",
                titleHelp: "Reglas que determinan cuándo el AI debe detenerse y transferir la conversación a un agente humano. Activa reglas integradas o agrega tus propias condiciones.",
                addCustomRule: "Agregar regla personalizada"
              },
              numberProfiles: {
                title: "Perfiles de Números WhatsApp",
                description: "Configure el comportamiento de AI por número de WhatsApp. Cada número puede tener su propio modo de bot, colas de AI y preguntas de recopilación.",
                noNumbers: "No se encontraron números de WhatsApp. Agregue una conexión primero.",
                saveProfile: "Guardar Perfil",
                saved: "¡Perfil guardado!",
                saveFailed: "Error al guardar el perfil",
                modeChatbot: "Chatbot AI (categorías → preguntas → productos)",
                modeDirect: "AI Directo (conversación libre)",
                modeOff: "Desactivado (solo bot de menú clásico)",
                systemPromptOverride: "Anulación del Prompt del Sistema",
                systemPromptOverrideHelp: "Reemplaza el prompt general de la empresa para este número. Deja vacío para usar el prompt predeterminado.",
                systemPromptPlaceholder: "Dejar vacío para usar el prompt predeterminado de la empresa",
                aiQueuesTitle: "Colas del Bot AI",
                aiQueuesHelp: "Define categorías de servicio que el cliente puede elegir. Cada cola puede tener sus propias preguntas, creación automática de tareas y plantilla de resumen. Ejemplo: 'Solicitud de Servicio', 'Facturación', 'Preguntas Generales'.",
                queueName: "Nombre de Cola",
                queueNameHelp: "El nombre mostrado al cliente en el menú de selección. Usa nombres claros y simples.",
                queueDescription: "Descripción",
                queueDescriptionHelp: "Una breve descripción de lo que maneja esta cola. Ayuda al AI a dirigir clientes correctamente.",
                addQueue: "Agregar Cola AI"
              },
              chatbotSettings: {
                title: "Configuración del Chatbot",
                description: "Configure cómo el chatbot gestiona las conversaciones entrantes antes de transferir a un agente.",
                botMode: "Modo de Bot",
                botModeHelp: "Elige cómo interactúa el AI con los clientes. AI Chatbot = flujo estructurado con menús y preguntas. AI Directo = conversación AI libre. Apagado = sin AI, solo menú clásico.",
                botModeMenu: "Bot de menú (paso a paso)",
                botModeAI: "Bot AI (conversacional)",
                botModeHelper: "El bot de menú usa menús fijos. El bot AI conduce una conversación natural para recopilar información.",
                questionsTitle: "Preguntas de Recopilación",
                questionsHelp: "Preguntas que el bot hace antes de transferir a un agente humano. Cada pregunta tiene un nombre de campo (uso interno) y el texto mostrado al cliente.",
                questionsDescription: "Defina la información que el AI debe recopilar del cliente antes de transferir a un agente.",
                addQuestion: "Agregar Pregunta",
                questionField: "Nombre del campo",
                questionFieldHelp: "Un nombre interno corto para este dato. Se usa en plantillas y sincronización CRM. Ejemplo: name, address, description, budget.",
                questionFieldHelper: "Nombre interno del campo (ej: destino, presupuesto)",
                questionText: "Texto de la pregunta",
                questionTextHelp: "La pregunta exacta que el bot hará al cliente. Escríbela en el idioma del cliente. Ejemplo: '¿Cuál es tu nombre?'",
                questionTextHelper: "La pregunta que el AI hará al cliente",
                questionRequired: "Obligatorio",
                questionRequiredHelp: "Si está activado, el bot seguirá preguntando hasta que el cliente responda. Si está desactivado, el cliente puede omitir la pregunta.",
                questionOptions: "Opciones (separadas por coma)",
                questionOptionsHelper: "Dejar vacío para texto libre. Ej: Electrónica, Joyería, Ropa. 1-3 = botones, 4+ = lista.",
                noQuestions: "No se han configurado preguntas. El AI conversará libremente sin recopilar datos específicos.",
                defaultQueue: "Cola por defecto",
                defaultQueueHelper: "Cola para asignar tickets cuando el AI no puede determinar la correcta",
                noQueue: "Sin cola por defecto",
                autoCreateTask: "Crear tarea automáticamente después de la toma",
                autoCreateTaskHelp: "Cuando está activado, se crea automáticamente una tarea en el sistema después de que el cliente complete todas las preguntas. Útil para solicitudes de servicio.",
                summaryTemplate: "Plantilla de resumen",
                summaryTemplateHelp: "El mensaje de confirmación enviado al cliente después de completar el formulario. Usa {{field}} para insertar datos recopilados.",
                summaryTemplatePlaceholder: "ej. *¡Solicitud recibida!*\nNombre: {{name}}\nDirección: {{address}}",
                summaryTemplateHelper: "Use {{field}} como marcadores. Deje vacío para usar la plantilla de la empresa."
              },
              greeting: {
                title: "Saludo",
                titleHelp: "El mensaje de bienvenida se envía automáticamente cuando un cliente escribe por primera vez o después de un largo período de inactividad.",
                enableGreeting: "Habilitar saludo automático",
                greetingMessage: "Mensaje de saludo",
                greetingMessageHelp: "El primer mensaje que ve el cliente. Incluye una bienvenida, el nombre de tu empresa y en qué puede ayudar el bot."
              },
              sections: {
                general: "Configuración General",
                generalDesc: "Identidad de la empresa, modelo de IA, idioma y configuración de saludo",
                generalHelp: "Configuración básica: nombre de la empresa, idioma preferido, modelo AI y el mensaje de bienvenida que los clientes ven primero.",
                chatbotFlow: "Flujo del Chatbot",
                chatbotFlowDesc: "Modo de bot WhatsApp, colas, preguntas de entrada y automatización de tareas",
                chatbotFlowHelp: "Configura cómo el bot recopila información de los clientes. Configura menús, preguntas y creación automática de tareas por número de WhatsApp.",
                productSearch: "Búsqueda de Productos",
                productSearchDesc: "Fuentes de datos, filtrado de productos y estructura de categorías para el catálogo",
                productSearchHelp: "Conecta el AI a tu catálogo de productos/servicios. El AI buscará y mostrará artículos relevantes a los clientes durante las conversaciones.",
                externalCrm: "CRM Externo",
                externalCrmDesc: "Conectar a una base de datos externa (Supabase) para búsqueda de clientes, sincronización de tareas y pagos",
                advanced: "Avanzado",
                advancedDesc: "Reglas de transferencia y otras configuraciones avanzadas",
                advancedHelp: "Define cuándo el AI debe detenerse y transferir la conversación a un agente humano.",
                active: "Activo"
              },
              crm: {
                enableIntegration: "Habilitar integración CRM externo",
                connectionTitle: "Conexión",
                connectionHelp: "Introduce la URL de tu proyecto Supabase y la clave API. Puedes encontrarlas en el panel de Supabase en Settings → API.",
                supabaseUrl: "URL de Supabase",
                supabaseKey: "Clave API de Supabase",
                testConnection: "Probar Conexión",
                edgeFunctionPath: "Ruta Edge Function (opcional)",
                edgeFunctionPathHelp: "Si se configura, las consultas pasan por Edge Function en lugar de REST directo. Ejemplo: /functions/v1/crm-api",
                customerLookupTitle: "Búsqueda de Cliente",
                customerLookupHelp: "Cuando un cliente envía un mensaje por WhatsApp, el bot buscará en tu base de datos por número de teléfono y completará automáticamente sus datos (nombre, dirección, etc.). Así el bot no hará preguntas cuyas respuestas ya conoce.",
                customerLookupDesc: "Rellenar automáticamente los datos del cliente desde la base de datos cuando envían un mensaje. Reduce las preguntas de entrada.",
                tableName: "Nombre de Tabla",
                tableNameHelp: "El nombre de la tabla en tu base de datos que contiene los registros de clientes. Ejemplo: customers, contacts, tenants",
                phoneField: "Columna de Teléfono",
                phoneFieldHelp: "El nombre de la columna en tu tabla que almacena números de teléfono. Ejemplo: phone, mobile, tenant_phone",
                nameFields: "Columnas de Nombre",
                nameFieldsHelp: "Nombres de columnas separados por comas, ej. first_name, last_name",
                extraField1: "Campo Extra 1 (opcional)",
                extraField1Help: "Campo adicional para autocompletar, ej. dirección, departamento, empresa",
                extraField2: "Campo Extra 2 (opcional)",
                extraField2Help: "Otro campo adicional, ej. apartamento, unidad, ID de cuenta",
                cachedFields: "Campos a recordar (separados por coma)",
                cachedFieldsHelp: "Campos extra de la respuesta de búsqueda que deben recordarse para usos posteriores (p. ej. building_id, apartment_id, customer_id). Obligatorio cuando la plantilla de tarea referencia {notes.<field>}.",
                detectedFields: "Columnas detectadas",
                taskSyncTitle: "Sincronización de Tareas",
                taskSyncHelp: "Sincronización automática de tareas creadas por el bot con tu base de datos externa. Cuando un cliente completa un formulario, se crea un registro de tarea en el CRM.",
                taskTable: "Tabla de Tareas",
                syncTasksToCrm: "Sincronizar tareas con CRM",
                defaultTaskType: "Tipo de tarea por defecto",
                defaultTaskTypeHelp: "Se usa cuando ninguna palabra clave coincide. Elige un valor que tu CRM siempre acepte (p. ej. repair, general).",
                requireFields: "Campos requeridos (separados por coma)",
                requireFieldsHelp: "Omitir la llamada al CRM externo si falta alguno de estos campos en notes. Previene errores 400 cuando la búsqueda no encuentra coincidencia.",
                taskTypeMap: "Mapa de tipos de tarea (JSON)",
                taskTypeMapHelp: 'Mapea cada task_type que tu CRM acepta a una lista de palabras clave. Gana la primera coincidencia (subcadena sin distinguir mayúsculas en el nombre de la cola). Ejemplo: {"emergency": ["leak","fire"], "repair": ["broken","fix"]}',
                payloadTemplate: "Plantilla de cuerpo create_task (JSON)",
                payloadTemplateHelp: "Forma del cuerpo que tu CRM espera para create_task. Usa los marcadores {{title}}, {{taskType}}, {{priority}}, {{description}}, {{phone}}, {notes.<field>}. Déjalo vacío para usar el cuerpo por defecto.",
                advanced: {
                  title: "Avanzado — mapeo de tipo de tarea y plantilla",
                  description: "Rellena solo si tu CRM impone un enum estricto para task_type o una forma de cuerpo personalizada. Los valores por defecto funcionan en la mayoría de instalaciones de Supabase.",
                  jsonParseError: "JSON inválido",
                  jsonMustBeObject: "El JSON debe ser un objeto"
                },
                paymentCheckTitle: "Verificación de Pagos",
                paymentCheckHelp: "Permite al bot verificar el estado de pago desde tu base de datos. Cuando un cliente pregunta sobre pagos, el bot puede buscar su saldo e historial de pagos.",
                paymentTable: "Tabla de Pagos",
                paymentStatusField: "Columna de Estado"
              },
              companyKnowledge: {
                title: "Conocimiento de la empresa",
                description: "Perfil de negocio, reglas, FAQ — se inyectan en el prompt del sistema de IA para cada chat con clientes.",
                profile: "Perfil de negocio",
                overview: "Descripción del negocio",
                overviewPlaceholder: "¿Qué hace tu negocio, a quién sirves? (2-3 frases)",
                serviceAreas: "Áreas de servicio (separadas por comas)",
                escalationPhone: "Teléfono de escalación",
                escalationEmail: "Email de escalación",
                communication: "Estilo de comunicación",
                addressForm: "Forma de tratamiento",
                toneStyle: "Tono y estilo",
                stopTopics: "Temas a EVITAR (separados por comas)",
                disclaimers: "Avisos obligatorios (separados por comas)",
                rules: "Reglas del negocio",
                addRule: "Añadir regla",
                neverDo: "Prohibiciones absolutas",
                addNeverDo: "Añadir prohibición",
                neverDoPlaceholder: "Nunca discutas precios de competidores",
                faq: "FAQ",
                addFaq: "Añadir FAQ",
                faqQuestion: "Pregunta",
                faqAnswer: "Respuesta"
              }
            },
            sitePages: {
              sidebarHeading: "Páginas",
              selectPage: "Selecciona una página para editar",
              loadError: "Error al cargar las páginas",
              saveSuccess: "Página guardada",
              saveError: "Error al guardar",
              statusError: "Error al actualizar el estado",
              published: "Página publicada",
              unpublished: "Página marcada como borrador",
              statusPublished: "Publicado",
              statusDraft: "Borrador",
              setDraft: "Marcar como borrador",
              publish: "Publicar página",
              save: "Guardar",
              saving: "Guardando…",
              fieldTitle: "Título de la página",
              fieldMetaTitle: "Meta Title",
              fieldMetaDesc: "Meta Description",
              fieldBody: "Contenido de la página (HTML)",
              metaTitleHint: "Máximo 70 caracteres. Google lo usa como título de la página en los resultados de búsqueda.",
              metaDescHint: "Máximo 160 caracteres. Se muestra bajo el título en los resultados de búsqueda de Google.",
              bodyHint: "Contenido HTML completo de la página. Se muestra tal cual en whapiz.com.",
              tooLong: "Demasiado largo — Google lo truncará",
              slugs: {
                termsOfService: "Términos del servicio",
                privacyPolicy: "Política de privacidad",
                aboutUs: "Acerca de nosotros",
                cookiePolicy: "Política de cookies"
              }
            }
          }
        }
      };

export { messages };
